import React, { useMemo } from 'react';
import { IconProps, Icons } from './interface';

export function Icon({ name, width, height, fill }: IconProps) {
  const iconWidth = useMemo(() => width || 24, [width]);
  const iconHeight = useMemo(() => height || 24, [height]);

  if (name === Icons.Warning) {
    return (
      <svg
        width={iconWidth}
        height={iconHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          stroke={fill || '#2D3C3C'}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9502 15.45H12.0502V15.55H11.9502V15.45Z"
          stroke={fill || '#2D3C3C'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 8.44995V12.45"
          stroke={fill || '#2D3C3C'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === Icons.Error) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3681_21755)">
          <path
            d="M21.5259 18.5L12.8657 3.5C12.4808 2.83333 11.5185 2.83333 11.1336 3.5L2.47336 18.5C2.08846 19.1667 2.56958 20 3.33938 20H20.6599C21.4297 20 21.9108 19.1667 21.5259 18.5Z"
            fill="#FF3B3B"
          />
          <path
            d="M11.9502 16H12.0502V16.1H11.9502V16Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 9V13"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_3681_21755">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (name === Icons.Success) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2092_40877)">
          <circle cx="12" cy="12" r="9" fill="#009969" />
          <path
            d="M15 10L11 14L9 12"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2092_40877">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (name === Icons.Cancel) {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 1.57L10.8.35 6 5.228 1.2.351 0 1.57l4.8 4.876L0 11.323l1.2 1.219L6 7.665l4.8 4.877 1.2-1.22-4.8-4.876L12 1.57z"
          fill={fill || '#000'}
        />
      </svg>
    );
  }
  if (name === Icons.Info) {
    return (
      <svg
        width={iconWidth}
        height={iconHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          stroke={fill || '#7A7C87'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 11V16"
          stroke={fill || '#7A7C87'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9502 8H12.0502V8.1H11.9502V8Z"
          stroke={fill || '#7A7C87'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === Icons.ActivityIndicator) {
    return (
      <svg
        className="z-10 -ml-1 mr-3 h-5 w-5 animate-spin text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    );
  }
  if (name === Icons.ArrowUp) {
    return (
      <svg
        width={iconWidth}
        height={iconHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.1304 17.51L21.9004 15.73L12.0004 5.84L2.10039 15.74L3.87039 17.51L12.0004 9.38L20.1304 17.51V17.51Z"
          fill={fill || '#2D3C3C'}
        />
      </svg>
    );
  }
  if (name === Icons.ArrowDown) {
    return (
      <svg
        width={iconWidth}
        height={iconHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.86961 6.49L2.09961 8.27L11.9996 18.16L21.8996 8.26L20.1296 6.49L11.9996 14.62L3.86961 6.49Z"
          fill={fill || '#2D3C3C'}
        />
      </svg>
    );
  }
  if (name === Icons.Hamburger) {
    return (
      <svg
        width={iconWidth}
        height={iconHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="4"
          y1="5"
          x2="20"
          y2="5"
          stroke="#2D3C3C"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="4"
          y1="11.1653"
          x2="15"
          y2="11.1653"
          stroke="#2D3C3C"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="4"
          y1="17.3305"
          x2="20"
          y2="17.3305"
          stroke="#2D3C3C"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (name === Icons.Chat) {
    return (
      <svg
        width={32}
        height={30}
        viewBox="0 0 32 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M32 14c0 7.732-7.164 14-16 14a18.12 18.12 0 01-4.694-.612c-1.168.592-3.85 1.728-8.362 2.468-.4.064-.704-.352-.546-.724.708-1.672 1.348-3.9 1.54-5.932C1.488 20.74 0 17.52 0 14 0 6.268 7.164 0 16 0s16 6.268 16 14zm-22 0a2 2 0 10-4 0 2 2 0 004 0zm8 0a2 2 0 10-4 0 2 2 0 004 0zm6 2a2 2 0 100-4 2 2 0 000 4z"
          fill="#F60"
        />
      </svg>
    );
  }
  if (name === Icons.ArrowRightBG) {
    return (
      <svg
        width={33}
        height={33}
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_564_9670)">
          <path
            d="M16.443 32.788c8.851 0 16.026-7.175 16.026-16.026 0-8.85-7.175-16.025-16.026-16.025C7.593.737.418 7.912.418 16.762c0 8.85 7.175 16.026 16.025 16.026z"
            fill="#F60"
          />
          <path
            d="M18.848 11.153l-1.13 1.13 3.67 3.678H8.432v1.603h12.956L17.71 21.24l1.138 1.13 5.609-5.609-5.609-5.609z"
            fill="#fff"
          />
        </g>
        <defs>
          <clipPath id="clip0_564_9670">
            <path fill="#fff" d="M0 0H33V33H0z" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (name === Icons.CheckMark) {
    return (
      <svg
        width={width || 19}
        height={height || 17}
        viewBox="0 0 19 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.085 8.291c0-1.231.326-2.441.946-3.508A7.043 7.043 0 015.62 2.215a7.115 7.115 0 017.071 0 .647.647 0 00.875-.235.633.633 0 00-.232-.87A8.413 8.413 0 003.247 2.429 8.265 8.265 0 00.87 7.208a8.234 8.234 0 001.048 5.226 8.336 8.336 0 004.039 3.515 8.42 8.42 0 005.36.349 8.36 8.36 0 004.468-2.96 8.247 8.247 0 001.727-5.047.635.635 0 00-.188-.45.646.646 0 00-1.097.45c0 1.86-.745 3.645-2.071 4.96a7.1 7.1 0 01-5 2.055 7.1 7.1 0 01-5-2.055 6.986 6.986 0 01-2.071-4.96z"
          fill="#353535"
        />
        <path
          d="M18.61 2.365a.639.639 0 00.14-.695.639.639 0 00-.594-.395.648.648 0 00-.455.187L9.156 9.94 5.754 6.564a.644.644 0 00-.91 0 .638.638 0 000 .903L8.7 11.293a.644.644 0 00.91 0l9-8.928z"
          fill="#353535"
        />
      </svg>
    );
  }
  if (name === Icons.Facebook) {
    return (
      <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_564_9735)">
          <path
            d="M10 .4A9.6 9.6 0 00.4 10a9.6 9.6 0 009.6 9.6 9.6 9.6 0 009.6-9.6A9.6 9.6 0 0010 .4zm2.274 6.634h-1.443c-.17 0-.36.225-.36.524V8.6h1.804l-.273 1.486H10.47v4.46H8.767v-4.46H7.222V8.6h1.545v-.874c0-1.254.87-2.273 2.064-2.273h1.443v1.58z"
            fill="#F60"
          />
        </g>
        <defs>
          <clipPath id="clip0_564_9735">
            <path fill="#fff" d="M0 0H20V20H0z" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (name === Icons.Twitter) {
    return (
      <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 1.25a8.75 8.75 0 10.001 17.501A8.75 8.75 0 0010 1.25zm4.205 6.596c.006.091.006.187.006.281 0 2.867-2.184 6.17-6.174 6.17a6.152 6.152 0 01-3.332-.973c.176.02.344.028.524.028 1.015 0 1.949-.344 2.693-.926a2.17 2.17 0 01-2.027-1.504c.334.049.634.049.978-.04a2.168 2.168 0 01-1.736-2.128v-.027c.287.162.625.261.978.275a2.17 2.17 0 01-.672-2.898A6.158 6.158 0 009.916 8.37c-.307-1.475.795-2.668 2.12-2.668.624 0 1.187.262 1.583.684.49-.092.96-.276 1.377-.522a2.16 2.16 0 01-.953 1.194 4.29 4.29 0 001.25-.338 4.548 4.548 0 01-1.088 1.125z"
          fill="#F60"
        />
      </svg>
    );
  }
  if (name === Icons.LinkedIn) {
    return (
      <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_564_9740)">
          <path
            d="M10 .4A9.6 9.6 0 00.4 10a9.6 9.6 0 009.6 9.6 9.6 9.6 0 009.6-9.6A9.6 9.6 0 0010 .4zM7.65 13.979H5.706V7.723H7.65v6.256zm-.984-7.024c-.614 0-1.01-.435-1.01-.973 0-.55.408-.971 1.035-.971s1.011.422 1.023.97c0 .539-.396.974-1.048.974zm8.084 7.024h-1.944v-3.467c0-.807-.282-1.355-.985-1.355-.537 0-.856.37-.997.728-.052.127-.065.307-.065.486v3.607H8.814v-4.26c0-.781-.025-1.434-.05-1.996h1.688l.09.869h.038c.256-.408.883-1.01 1.932-1.01 1.28 0 2.238.857 2.238 2.699v3.699z"
            fill="#F60"
          />
        </g>
        <defs>
          <clipPath id="clip0_564_9740">
            <path fill="#fff" d="M0 0H20V20H0z" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (name === Icons.Instagram) {
    return (
      <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_564_9742)">
          <path
            d="M13 10a3 3 0 01-6 0c0-.171.018-.338.05-.5H6v3.997c0 .278.225.503.503.503h6.995a.503.503 0 00.502-.503V9.5h-1.049c.031.162.05.329.05.5zm-3 2A2.001 2.001 0 1010 7.998 2.001 2.001 0 0010 12zm2.4-4.1h1.2a.301.301 0 00.3-.3V6.4a.3.3 0 00-.3-.3h-1.2a.3.3 0 00-.3.3v1.2c0 .165.135.3.3.3zM10 .4a9.6 9.6 0 100 19.2A9.6 9.6 0 0010 .4zm5 13.489c0 .61-.5 1.11-1.11 1.11H6.11c-.61 0-1.11-.5-1.11-1.11V6.11C5 5.5 5.5 5 6.11 5h7.778C14.5 5 15 5.5 15 6.11v7.779z"
            fill="#F60"
          />
        </g>
        <defs>
          <clipPath id="clip0_564_9742">
            <path fill="#fff" d="M0 0H20V20H0z" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (name === Icons.ArrowRight) {
    return (
      <svg
        width={width || 22}
        height={height || 16}
        viewBox="0 0 22 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 1l7 7-7 7M20.5 8H1"
          stroke={fill || '#fff'}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === Icons.Search) {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.7429 10.344C12.7112 9.02267 13.1449 7.38447 12.9572 5.75713C12.7695 4.12979 11.9743 2.63332 10.7307 1.56711C9.48701 0.500899 7.88665 -0.056418 6.24973 0.00665514C4.61282 0.0697283 3.06008 0.748541 1.90217 1.90729C0.744249 3.06603 0.0665484 4.61926 0.00464653 6.25621C-0.0572553 7.89317 0.501207 9.49314 1.56831 10.736C2.6354 11.9789 4.13244 12.773 5.75992 12.9596C7.38739 13.1461 9.02528 12.7112 10.3459 11.742H10.3449C10.3749 11.782 10.4069 11.82 10.4429 11.857L14.2929 15.707C14.4804 15.8946 14.7348 16.0001 15 16.0002C15.2653 16.0003 15.5198 15.895 15.7074 15.7075C15.895 15.52 16.0005 15.2656 16.0006 15.0003C16.0007 14.7351 15.8954 14.4806 15.7079 14.293L11.8579 10.443C11.8221 10.4068 11.7837 10.3734 11.7429 10.343V10.344ZM12.0009 6.49998C12.0009 7.22225 11.8586 7.93745 11.5822 8.60474C11.3058 9.27203 10.9007 9.87834 10.39 10.3891C9.87926 10.8998 9.27295 11.3049 8.60566 11.5813C7.93837 11.8577 7.22317 12 6.5009 12C5.77863 12 5.06343 11.8577 4.39614 11.5813C3.72885 11.3049 3.12253 10.8998 2.61181 10.3891C2.10109 9.87834 1.69596 9.27203 1.41956 8.60474C1.14316 7.93745 1.0009 7.22225 1.0009 6.49998C1.0009 5.04129 1.58036 3.64234 2.61181 2.61089C3.64326 1.57944 5.04221 0.999979 6.5009 0.999979C7.95959 0.999979 9.35853 1.57944 10.39 2.61089C11.4214 3.64234 12.0009 5.04129 12.0009 6.49998Z"
          fill="#C4C4C4"
        />
      </svg>
    );
  }
  if (name === Icons.DashboardHamburger) {
    return (
      <svg
        className="h-6 w-6"
        aria-hidden="true"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          clipRule="evenodd"
          fillRule="evenodd"
          d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
        />
      </svg>
    );
  }
  if (name === Icons.Profile) {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.08937 10.1475C9.07437 10.1475 9.05187 10.1475 9.03687 10.1475C9.01437 10.1475 8.98437 10.1475 8.96187 10.1475C7.25937 10.095 5.98438 8.76749 5.98438 7.13249C5.98438 5.46749 7.34188 4.10999 9.00687 4.10999C10.6719 4.10999 12.0294 5.46749 12.0294 7.13249C12.0219 8.77499 10.7394 10.095 9.11187 10.1475C9.09687 10.1475 9.09687 10.1475 9.08937 10.1475ZM8.99937 5.22749C7.94937 5.22749 7.10188 6.08249 7.10188 7.12498C7.10188 8.15248 7.90437 8.98498 8.92437 9.02248C8.94687 9.01498 9.02187 9.01498 9.09687 9.02248C10.1019 8.96998 10.8894 8.14499 10.8969 7.12498C10.8969 6.08249 10.0494 5.22749 8.99937 5.22749Z"
          fill="#62686D"
        />
        <path
          d="M9.00061 17.0625C6.98311 17.0625 5.05561 16.3125 3.56311 14.9475C3.42811 14.8275 3.36811 14.6475 3.38311 14.475C3.48061 13.5825 4.03561 12.75 4.95811 12.135C7.19311 10.65 10.8156 10.65 13.0431 12.135C13.9656 12.7575 14.5206 13.5825 14.6181 14.475C14.6406 14.655 14.5731 14.8275 14.4381 14.9475C12.9456 16.3125 11.0181 17.0625 9.00061 17.0625ZM4.56061 14.325C5.80561 15.3675 7.37311 15.9375 9.00061 15.9375C10.6281 15.9375 12.1956 15.3675 13.4406 14.325C13.3056 13.8675 12.9456 13.425 12.4131 13.065C10.5681 11.835 7.44061 11.835 5.58061 13.065C5.04811 13.425 4.69561 13.8675 4.56061 14.325Z"
          fill="#62686D"
        />
        <path
          d="M9 17.0625C4.5525 17.0625 0.9375 13.4475 0.9375 9C0.9375 4.5525 4.5525 0.9375 9 0.9375C13.4475 0.9375 17.0625 4.5525 17.0625 9C17.0625 13.4475 13.4475 17.0625 9 17.0625ZM9 2.0625C5.175 2.0625 2.0625 5.175 2.0625 9C2.0625 12.825 5.175 15.9375 9 15.9375C12.825 15.9375 15.9375 12.825 15.9375 9C15.9375 5.175 12.825 2.0625 9 2.0625Z"
          fill="#62686D"
        />
      </svg>
    );
  }
  if (name === Icons.Logout) {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.4304 16.7025H11.3329C8.00288 16.7025 6.39788 15.39 6.12038 12.45C6.09038 12.1425 6.31538 11.865 6.63038 11.835C6.93038 11.805 7.21538 12.0375 7.24538 12.345C7.46288 14.7 8.57288 15.5775 11.3404 15.5775H11.4379C14.4904 15.5775 15.5704 14.4975 15.5704 11.445V6.55499C15.5704 3.50249 14.4904 2.42249 11.4379 2.42249H11.3404C8.55788 2.42249 7.44788 3.31499 7.24538 5.71499C7.20788 6.02249 6.94538 6.25499 6.63038 6.22499C6.31538 6.20249 6.09038 5.92499 6.11288 5.61749C6.36788 2.63249 7.98038 1.29749 11.3329 1.29749H11.4304C15.1129 1.29749 16.6879 2.87249 16.6879 6.55499V11.445C16.6879 15.1275 15.1129 16.7025 11.4304 16.7025Z"
          fill="#62686D"
        />
        <path
          d="M11.2498 9.5625H2.71484C2.40734 9.5625 2.15234 9.3075 2.15234 9C2.15234 8.6925 2.40734 8.4375 2.71484 8.4375H11.2498C11.5573 8.4375 11.8123 8.6925 11.8123 9C11.8123 9.3075 11.5573 9.5625 11.2498 9.5625Z"
          fill="#62686D"
        />
        <path
          d="M4.38758 12.075C4.24508 12.075 4.10258 12.0225 3.99008 11.91L1.47758 9.3975C1.26008 9.18 1.26008 8.82001 1.47758 8.60251L3.99008 6.09C4.20758 5.8725 4.56758 5.8725 4.78508 6.09C5.00258 6.3075 5.00258 6.66751 4.78508 6.88501L2.67008 9.00001L4.78508 11.115C5.00258 11.3325 5.00258 11.6925 4.78508 11.91C4.68008 12.0225 4.53008 12.075 4.38758 12.075Z"
          fill="#62686D"
        />
      </svg>
    );
  }
  if (name === Icons.Notification) {
    return (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.3125 12.9578V10.9375H18.75V13.2812C18.75 13.4884 18.8324 13.6871 18.9789 13.8336L21.0938 15.9484V17.1875H3.90625V15.9484L6.02109 13.8336C6.16762 13.6871 6.24996 13.4884 6.25 13.2812V10.1562C6.24782 9.05843 6.53539 7.97948 7.08366 7.02837C7.63193 6.07726 8.42149 5.28768 9.37258 4.73938C10.3237 4.19108 11.4026 3.90347 12.5004 3.90561C13.5982 3.90775 14.6761 4.19956 15.625 4.75156V3.00547C14.8813 2.67619 14.0903 2.46632 13.2812 2.38359V0.78125H11.7188V2.38281C9.79264 2.57885 8.00763 3.48212 6.70888 4.91795C5.41014 6.35379 4.68992 8.22019 4.6875 10.1562V12.9578L2.57266 15.0727C2.42613 15.2191 2.34379 15.4178 2.34375 15.625V17.9688C2.34375 18.176 2.42606 18.3747 2.57257 18.5212C2.71909 18.6677 2.9178 18.75 3.125 18.75H8.59375V19.5312C8.59375 20.5673 9.0053 21.5608 9.73786 22.2934C10.4704 23.0259 11.464 23.4375 12.5 23.4375C13.536 23.4375 14.5296 23.0259 15.2621 22.2934C15.9947 21.5608 16.4062 20.5673 16.4062 19.5312V18.75H21.875C22.0822 18.75 22.2809 18.6677 22.4274 18.5212C22.5739 18.3747 22.6562 18.176 22.6562 17.9688V15.625C22.6562 15.4178 22.5739 15.2191 22.4273 15.0727L20.3125 12.9578ZM14.8438 19.5312C14.8438 20.1529 14.5968 20.749 14.1573 21.1885C13.7177 21.6281 13.1216 21.875 12.5 21.875C11.8784 21.875 11.2823 21.6281 10.8427 21.1885C10.4032 20.749 10.1562 20.1529 10.1562 19.5312V18.75H14.8438V19.5312Z"
          fill="#5C6B7E"
        />
        <path
          d="M20.3125 9.375C22.0384 9.375 23.4375 7.97589 23.4375 6.25C23.4375 4.52411 22.0384 3.125 20.3125 3.125C18.5866 3.125 17.1875 4.52411 17.1875 6.25C17.1875 7.97589 18.5866 9.375 20.3125 9.375Z"
          fill={fill || '#FF6600'}
        />
      </svg>
    );
  }
  if (name === Icons.Dashboard) {
    return (
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.50039 3.90002C5.81083 3.90002 5.14951 4.17395 4.66191 4.66155C4.17432 5.14914 3.90039 5.81046 3.90039 6.50002V9.10002C3.90039 9.78959 4.17432 10.4509 4.66191 10.9385C5.14951 11.4261 5.81083 11.7 6.50039 11.7H9.10039C9.78995 11.7 10.4513 11.4261 10.9389 10.9385C11.4265 10.4509 11.7004 9.78959 11.7004 9.10002V6.50002C11.7004 5.81046 11.4265 5.14914 10.9389 4.66155C10.4513 4.17395 9.78995 3.90002 9.10039 3.90002H6.50039ZM6.50039 14.3C5.81083 14.3 5.14951 14.574 4.66191 15.0615C4.17432 15.5491 3.90039 16.2105 3.90039 16.9V19.5C3.90039 20.1896 4.17432 20.8509 4.66191 21.3385C5.14951 21.8261 5.81083 22.1 6.50039 22.1H9.10039C9.78995 22.1 10.4513 21.8261 10.9389 21.3385C11.4265 20.8509 11.7004 20.1896 11.7004 19.5V16.9C11.7004 16.2105 11.4265 15.5491 10.9389 15.0615C10.4513 14.574 9.78995 14.3 9.10039 14.3H6.50039ZM14.3004 6.50002C14.3004 5.81046 14.5743 5.14914 15.0619 4.66155C15.5495 4.17395 16.2108 3.90002 16.9004 3.90002H19.5004C20.19 3.90002 20.8513 4.17395 21.3389 4.66155C21.8265 5.14914 22.1004 5.81046 22.1004 6.50002V9.10002C22.1004 9.78959 21.8265 10.4509 21.3389 10.9385C20.8513 11.4261 20.19 11.7 19.5004 11.7H16.9004C16.2108 11.7 15.5495 11.4261 15.0619 10.9385C14.5743 10.4509 14.3004 9.78959 14.3004 9.10002V6.50002ZM14.3004 16.9C14.3004 16.2105 14.5743 15.5491 15.0619 15.0615C15.5495 14.574 16.2108 14.3 16.9004 14.3H19.5004C20.19 14.3 20.8513 14.574 21.3389 15.0615C21.8265 15.5491 22.1004 16.2105 22.1004 16.9V19.5C22.1004 20.1896 21.8265 20.8509 21.3389 21.3385C20.8513 21.8261 20.19 22.1 19.5004 22.1H16.9004C16.2108 22.1 15.5495 21.8261 15.0619 21.3385C14.5743 20.8509 14.3004 20.1896 14.3004 19.5V16.9Z"
          fill="white"
        />
      </svg>
    );
  }
  if (name === Icons.Assets) {
    return (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 8.74829V16.7483V8.74829ZM12 11.7483V16.7483V11.7483ZM8 14.7483V16.7483V14.7483ZM6 20.7483H18C18.5304 20.7483 19.0391 20.5376 19.4142 20.1625C19.7893 19.7874 20 19.2787 20 18.7483V6.74829C20 6.21786 19.7893 5.70915 19.4142 5.33408C19.0391 4.959 18.5304 4.74829 18 4.74829H6C5.46957 4.74829 4.96086 4.959 4.58579 5.33408C4.21071 5.70915 4 6.21786 4 6.74829V18.7483C4 19.2787 4.21071 19.7874 4.58579 20.1625C4.96086 20.5376 5.46957 20.7483 6 20.7483Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === Icons.Beneficiary) {
    return (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 20.1921H22V18.1921C22 17.5687 21.8057 16.9607 21.4441 16.4528C21.0826 15.9448 20.5718 15.5621 19.9827 15.3579C19.3937 15.1537 18.7556 15.138 18.1573 15.3132C17.5589 15.4883 17.03 15.8455 16.644 16.3351L17 20.1921ZM17 20.1921H7H17ZM17 20.1921V18.1921C17 17.5361 16.874 16.9091 16.644 16.3351L17 20.1921ZM7 20.1921H2V18.1921C2.00005 17.5687 2.19434 16.9607 2.55586 16.4528C2.91739 15.9448 3.42819 15.5621 4.01725 15.3579C4.60632 15.1537 5.24438 15.138 5.84274 15.3132C6.4411 15.4883 6.97003 15.8455 7.356 16.3351L7 20.1921ZM7 20.1921V18.1921C7 17.5361 7.126 16.9091 7.356 16.3351L7 20.1921ZM7.356 16.3351C7.72736 15.4071 8.36825 14.6116 9.196 14.0513C10.0238 13.4909 11.0004 13.1914 12 13.1914C12.9996 13.1914 13.9762 13.4909 14.804 14.0513C15.6318 14.6116 16.2726 15.4071 16.644 16.3351H7.356ZM15 7.19214C15 7.98779 14.6839 8.75085 14.1213 9.31346C13.5587 9.87607 12.7956 10.1921 12 10.1921C11.2044 10.1921 10.4413 9.87607 9.87868 9.31346C9.31607 8.75085 9 7.98779 9 7.19214C9 6.39649 9.31607 5.63343 9.87868 5.07082C10.4413 4.50821 11.2044 4.19214 12 4.19214C12.7956 4.19214 13.5587 4.50821 14.1213 5.07082C14.6839 5.63343 15 6.39649 15 7.19214V7.19214ZM21 10.1921C21 10.7226 20.7893 11.2313 20.4142 11.6064C20.0391 11.9814 19.5304 12.1921 19 12.1921C18.4696 12.1921 17.9609 11.9814 17.5858 11.6064C17.2107 11.2313 17 10.7226 17 10.1921C17 9.66171 17.2107 9.153 17.5858 8.77793C17.9609 8.40285 18.4696 8.19214 19 8.19214C19.5304 8.19214 20.0391 8.40285 20.4142 8.77793C20.7893 9.153 21 9.66171 21 10.1921ZM7 10.1921C7 10.7226 6.78929 11.2313 6.41421 11.6064C6.03914 11.9814 5.53043 12.1921 5 12.1921C4.46957 12.1921 3.96086 11.9814 3.58579 11.6064C3.21071 11.2313 3 10.7226 3 10.1921C3 9.66171 3.21071 9.153 3.58579 8.77793C3.96086 8.40285 4.46957 8.19214 5 8.19214C5.53043 8.19214 6.03914 8.40285 6.41421 8.77793C6.78929 9.153 7 9.66171 7 10.1921Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === Icons.Executors) {
    return (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.4316 21.7908H3.43164V20.7908C3.43164 19.1995 4.06378 17.6734 5.189 16.5481C6.31422 15.4229 7.84034 14.7908 9.43164 14.7908C11.0229 14.7908 12.5491 15.4229 13.6743 16.5481C14.7995 17.6734 15.4316 19.1995 15.4316 20.7908V21.7908ZM15.4316 21.7908H21.4316V20.7908C21.4318 19.7375 21.1547 18.7027 20.6281 17.7905C20.1016 16.8782 19.3441 16.1207 18.432 15.594C17.5199 15.0673 16.4851 14.79 15.4319 14.7899C14.3786 14.7899 13.3438 15.0671 12.4316 15.5938L15.4316 21.7908ZM12.4316 5.14477C12.9691 4.53547 13.6793 4.10428 14.4679 3.90857C15.2564 3.71285 16.0858 3.7619 16.8458 4.04917C17.6058 4.33645 18.2602 4.84834 18.7221 5.51673C19.184 6.18512 19.4314 6.97832 19.4314 7.79077C19.4314 8.60323 19.184 9.39642 18.7221 10.0648C18.2602 10.7332 17.6058 11.2451 16.8458 11.5324C16.0858 11.8196 15.2564 11.8687 14.4679 11.673C13.6793 11.4773 12.9691 11.0461 12.4316 10.4368V5.14477ZM13.4316 7.79077C13.4316 8.85164 13.0102 9.86905 12.2601 10.6192C11.5099 11.3693 10.4925 11.7908 9.43164 11.7908C8.37077 11.7908 7.35336 11.3693 6.60321 10.6192C5.85307 9.86905 5.43164 8.85164 5.43164 7.79077C5.43164 6.72991 5.85307 5.71249 6.60321 4.96235C7.35336 4.2122 8.37077 3.79077 9.43164 3.79077C10.4925 3.79077 11.5099 4.2122 12.2601 4.96235C13.0102 5.71249 13.4316 6.72991 13.4316 7.79077Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === Icons.Guardians) {
    return (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 16.0559H9.01M9 5.05591H7C6.46957 5.05591 5.96086 5.26662 5.58579 5.64169C5.21071 6.01677 5 6.52548 5 7.05591V19.0559C5 19.5863 5.21071 20.095 5.58579 20.4701C5.96086 20.8452 6.46957 21.0559 7 21.0559H17C17.5304 21.0559 18.0391 20.8452 18.4142 20.4701C18.7893 20.095 19 19.5863 19 19.0559V7.05591C19 6.52548 18.7893 6.01677 18.4142 5.64169C18.0391 5.26662 17.5304 5.05591 17 5.05591H15H9ZM9 5.05591C9 5.58634 9.21071 6.09505 9.58579 6.47012C9.96086 6.84519 10.4696 7.05591 11 7.05591H13C13.5304 7.05591 14.0391 6.84519 14.4142 6.47012C14.7893 6.09505 15 5.58634 15 5.05591H9ZM9 5.05591C9 4.52548 9.21071 4.01677 9.58579 3.64169C9.96086 3.26662 10.4696 3.05591 11 3.05591H13C13.5304 3.05591 14.0391 3.26662 14.4142 3.64169C14.7893 4.01677 15 4.52548 15 5.05591H9ZM12 12.0559H15H12ZM12 16.0559H15H12ZM9 12.0559H9.01H9Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === Icons.Trustees) {
    return (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_744_8328)">
          <g clipPath="url(#clip1_744_8328)">
            <path
              d="M11 24C11.9976 24 20 19.4106 20 13.9944V2.18185C17.6389 2.18126 11 1 11 1C11 1 4.35518 2.18126 2 2.18126V13.9938C2 19.4112 10.0024 24 11 24Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.0529 8H7.94706C6.31945 8 5 9.271 5 10.8389V15.1611C5 16.729 6.31945 18 7.94706 18H14.0529C15.6806 18 17 16.729 17 15.1611V10.8389C17 9.271 15.6806 8 14.0529 8Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 15H14.2012M7.7988 12H17H7.7988Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11 7C12.1046 7 13 6.10457 13 5C13 3.89543 12.1046 3 11 3C9.89543 3 9 3.89543 9 5C9 6.10457 9.89543 7 11 7Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_744_8328">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.134766 0.101318)"
            />
          </clipPath>
          <clipPath id="clip1_744_8328">
            <rect
              width="48"
              height="48"
              fill="white"
              transform="translate(0.134766 0.101318)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (name === Icons.Message) {
    return (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.24219 11.6626H8.25219H8.24219ZM12.2422 11.6626H12.2522H12.2422ZM16.2422 11.6626H16.2522H16.2422ZM21.2422 11.6626C21.2422 16.0806 17.2122 19.6626 12.2422 19.6626C10.7708 19.6676 9.31698 19.3434 7.98719 18.7136L3.24219 19.6626L4.63719 15.9426C3.75419 14.7046 3.24219 13.2366 3.24219 11.6626C3.24219 7.2446 7.27219 3.6626 12.2422 3.6626C17.2122 3.6626 21.2422 7.2446 21.2422 11.6626Z"
          stroke="#F2F2F2"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === Icons.Will) {
    return (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_431_5044)">
          <path
            d="M21.125 23.4375H8.9375C8.50666 23.4371 8.09358 23.2723 7.78893 22.9794C7.48427 22.6865 7.31293 22.2893 7.3125 21.875V17.1875H8.9375V21.875H21.125V4.6875H13.8125V3.125H21.125C21.5558 3.12541 21.9689 3.29017 22.2736 3.5831C22.5782 3.87604 22.7496 4.27323 22.75 4.6875V21.875C22.7496 22.2893 22.5782 22.6865 22.2736 22.9794C21.9689 23.2723 21.5558 23.4371 21.125 23.4375Z"
            fill="white"
          />
          <path d="M13.8125 7.8125H19.5V9.375H13.8125V7.8125Z" fill="white" />
          <path d="M13 11.7188H19.5V13.2812H13V11.7188Z" fill="white" />
          <path d="M12.1875 15.625H19.5V17.1875H12.1875V15.625Z" fill="white" />
          <path
            d="M7.3125 14.8438C6.23539 14.8427 5.2027 14.4308 4.44107 13.6985C3.67943 12.9662 3.25108 11.9732 3.25 10.9375V2.34375H4.875V10.9375C4.875 11.5591 5.13181 12.1552 5.58893 12.5948C6.04605 13.0343 6.66603 13.2812 7.3125 13.2812C7.95897 13.2812 8.57895 13.0343 9.03607 12.5948C9.49319 12.1552 9.75 11.5591 9.75 10.9375V3.90625C9.75 3.69905 9.6644 3.50034 9.51202 3.35382C9.35965 3.20731 9.15299 3.125 8.9375 3.125C8.72201 3.125 8.51535 3.20731 8.36298 3.35382C8.2106 3.50034 8.125 3.69905 8.125 3.90625V11.7188H6.5V3.90625C6.5 3.28465 6.75681 2.68851 7.21393 2.24897C7.67105 1.80943 8.29103 1.5625 8.9375 1.5625C9.58397 1.5625 10.204 1.80943 10.6611 2.24897C11.1182 2.68851 11.375 3.28465 11.375 3.90625V10.9375C11.3739 11.9732 10.9456 12.9662 10.1839 13.6985C9.4223 14.4308 8.38961 14.8427 7.3125 14.8438Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_431_5044">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.242188 -0.337402)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (name === Icons.Call) {
    return (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.24219 4.64893C3.24219 4.11849 3.4529 3.60978 3.82797 3.23471C4.20305 2.85964 4.71175 2.64893 5.24219 2.64893H8.52219C8.73198 2.64909 8.93641 2.71522 9.10654 2.83798C9.27668 2.96073 9.40389 3.13388 9.47019 3.33293L10.9682 7.82593C11.0441 8.05426 11.0351 8.30232 10.9429 8.52457C10.8507 8.74683 10.6814 8.92838 10.4662 9.03593L8.20919 10.1659C9.31551 12.6145 11.2766 14.5756 13.7252 15.6819L14.8552 13.4249C14.9627 13.2097 15.1443 13.0404 15.3665 12.9482C15.5888 12.856 15.8368 12.847 16.0652 12.9229L20.5582 14.4209C20.7574 14.4873 20.9307 14.6146 21.0534 14.785C21.1762 14.9553 21.2422 15.16 21.2422 15.3699V18.6489C21.2422 19.1794 21.0315 19.6881 20.6564 20.0631C20.2813 20.4382 19.7726 20.6489 19.2422 20.6489H18.2422C9.95819 20.6489 3.24219 13.9329 3.24219 5.64893V4.64893Z"
          stroke="#F2F2F2"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === Icons.QuickTips) {
    return (
      <svg
        width="29"
        height="30"
        viewBox="0 0 29 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.5264 1L26.0527 2.47368"
          stroke="#FF6600"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 1L2.47368 2.47368"
          stroke="#FF6600"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.5264 21.6316L26.0527 20.158"
          stroke="#FF6600"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 21.6316L2.47368 20.158"
          stroke="#FF6600"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.8418 24.5789H18.6839"
          stroke="#FF6600"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3164 29H17.2111"
          stroke="#FF6600"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.2652 2.47363C8.37046 2.47363 5.35235 5.34732 5.42309 9.84205C5.45699 12.0334 6.15993 13.5263 7.63362 14.9999C9.1073 16.4736 9.84414 17.2105 9.84414 20.1578H18.6862C18.6862 17.2105 19.4231 16.4736 20.8968 14.9999C22.3705 13.5263 23.0734 12.0334 23.1073 9.84205C23.178 5.34732 20.1599 2.47363 14.2652 2.47363Z"
          stroke="#FF6600"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === Icons.Bank) {
    return (
      <svg
        width={width || '15'}
        height={height || '15'}
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.02305 1.22839C7.16117 1.12658 7.32825 1.07166 7.49983 1.07166C7.67142 1.07166 7.8385 1.12658 7.97662 1.22839L13.0643 4.98107C13.6664 5.42571 13.3847 6.36214 12.6679 6.42749H2.3318C1.61501 6.36214 1.33376 5.42571 1.93537 4.98107L7.02358 1.22839H7.02305ZM7.49983 4.82089C7.71295 4.82089 7.91735 4.73622 8.06805 4.58553C8.21874 4.43483 8.30341 4.23044 8.30341 4.01731C8.30341 3.80419 8.21874 3.5998 8.06805 3.4491C7.91735 3.29841 7.71295 3.21374 7.49983 3.21374C7.28671 3.21374 7.08232 3.29841 6.93162 3.4491C6.78092 3.5998 6.69626 3.80419 6.69626 4.01731C6.69626 4.23044 6.78092 4.43483 6.93162 4.58553C7.08232 4.73622 7.28671 4.82089 7.49983 4.82089ZM10.4463 6.96374H11.785V10.178H10.4457V6.96374H10.4463ZM9.37483 10.178V6.96374H8.03555V10.178H9.37483ZM6.96412 10.1786V6.96428H5.62483V10.1786H6.96412ZM4.55394 10.1786V6.96428H3.21466V10.1786H4.55394ZM3.34858 10.7143C2.88682 10.7143 2.44397 10.8977 2.11746 11.2242C1.79095 11.5507 1.60751 11.9936 1.60751 12.4554V12.7232C1.60805 12.9455 1.78805 13.1255 2.0093 13.1255H12.9898C13.0964 13.1255 13.1986 13.0832 13.2739 13.0078C13.3493 12.9325 13.3916 12.8303 13.3916 12.7237V12.4559C13.3916 11.9941 13.2082 11.5513 12.8817 11.2248C12.5552 10.8982 12.1123 10.7148 11.6505 10.7148H3.34912L3.34858 10.7143Z"
          fill={fill || '#2F49D1'}
        />
      </svg>
    );
  }
  if (name === Icons.Stocks) {
    return (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.2439 14H1.75415C1.27155 14 0.859518 13.8291 0.518054 13.4873C0.176591 13.1455 0.00585937 12.7331 0.00585938 12.25V1.75C0.00585938 1.26693 0.176591 0.854492 0.518054 0.512695C0.859518 0.170898 1.27155 0 1.75415 0H12.2439C12.7265 0 13.1385 0.170898 13.48 0.512695C13.8215 0.854492 13.9922 1.26693 13.9922 1.75V12.25C13.9922 12.7331 13.8215 13.1455 13.48 13.4873C13.1385 13.8291 12.7265 14 12.2439 14ZM12.2439 3.5C12.2439 3.01693 12.0732 2.60449 11.7317 2.2627C11.3902 1.9209 10.9782 1.75 10.4956 1.75H3.50244C3.01984 1.75 2.60781 1.9209 2.26635 2.2627C1.92488 2.60449 1.75415 3.01693 1.75415 3.5V10.5C1.75415 10.9831 1.92488 11.3955 2.26635 11.7373C2.60781 12.0791 3.01984 12.25 3.50244 12.25H10.4956C10.9782 12.25 11.3902 12.0791 11.7317 11.7373C12.0732 11.3955 12.2439 10.9831 12.2439 10.5V3.5ZM10.7278 7.84766L9.9083 7.02734L7.34049 9.59766C7.28586 9.69792 7.23578 9.77083 7.19025 9.81641C7.02635 9.98047 6.8283 10.0625 6.5961 10.0625C6.36391 10.0625 6.16586 9.98047 6.00196 9.81641L5.25074 9.06445L4.04879 10.2539C3.88488 10.418 3.68683 10.5 3.45464 10.5C3.22244 10.5 3.0244 10.418 2.86049 10.2539C2.69659 10.0898 2.61464 9.8916 2.61464 9.65918C2.61464 9.42676 2.69659 9.22852 2.86049 9.06445L4.52683 7.39648C4.59057 7.30534 4.62244 7.25521 4.62244 7.24609C4.78635 7.08203 4.98439 7 5.21659 7C5.44878 7 5.64683 7.08203 5.81074 7.24609L6.5483 7.99805L8.70634 5.83789L7.87317 5.00391V4.92188C7.87317 4.79427 7.87545 4.69857 7.88 4.63477C7.88456 4.57096 7.91187 4.51172 7.96195 4.45703C8.01204 4.40234 8.08716 4.375 8.18732 4.375H10.7278C10.9099 4.375 11.0624 4.43652 11.1854 4.55957C11.3083 4.68262 11.3698 4.83073 11.3698 5.00391V7.5332C11.3698 7.63346 11.3424 7.70866 11.2878 7.75879C11.2332 7.80892 11.174 7.83626 11.1102 7.84082C11.0465 7.84538 10.9509 7.84766 10.8234 7.84766H10.7278Z"
          fill="#4BDE97"
        />
      </svg>
    );
  }
  if (name === Icons.Pension) {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_128_599)">
          <path
            d="M14.2587 8.65898L14.3754 7.37695C14.3754 5.67469 14.0475 4.31297 12.8466 3.41766C12.1894 2.10305 10.7248 0.468984 7.49859 0.46875C4.27406 0.46875 2.81016 2.10305 2.15344 3.41789C0.9525 4.31297 0.624609 5.67492 0.624609 7.37719L0.741328 8.65922C0.579375 8.8193 0.46875 9.06773 0.46875 9.43266C0.46875 10.4114 1.04109 10.5429 1.27594 10.5555C1.39266 12.5048 3.3518 14.5312 7.50023 14.5312C11.9048 14.5312 13.6057 12.2205 13.7236 10.5558C13.8675 10.5492 14.0599 10.5056 14.2247 10.3502C14.4284 10.1585 14.5312 9.84961 14.5312 9.43266C14.5312 9.06773 14.4206 8.8193 14.2587 8.65898ZM13.9845 10.0966C13.827 10.2448 13.5966 10.2002 13.5959 10.2005L13.3805 10.1489V10.3699C13.3805 11.9023 11.8144 14.1825 7.50023 14.1825C3.18609 14.1825 1.62023 11.9025 1.62023 10.3702L1.61859 10.1534L1.40625 10.2002C1.37705 10.2058 1.34737 10.2084 1.31766 10.208C0.904922 10.208 0.818203 9.78633 0.818203 9.43266C0.818203 8.88422 1.11094 8.76914 1.35633 8.76914C1.38094 8.76914 1.39734 8.77078 1.40016 8.77102L1.44469 8.77664L1.48687 8.76047C2.01961 8.55141 2.37539 8.23242 2.54461 7.81266C2.8718 6.99914 2.41664 6.01547 2.14453 5.42742C2.07539 5.27789 2.00367 5.12367 1.98492 5.05055C2.03719 4.66172 2.67703 0.817266 7.50023 0.817266C12.3227 0.817734 12.9633 4.66102 13.0153 5.05055C12.9963 5.12391 12.9251 5.27812 12.8557 5.42742C12.5836 6.01523 12.128 6.99914 12.4554 7.81266C12.6244 8.23242 12.9802 8.55141 13.5131 8.76047L13.5553 8.77617L13.5989 8.77125C13.6138 8.76974 13.6287 8.76904 13.6437 8.76914C13.8891 8.76914 14.1818 8.88422 14.1818 9.43266C14.1818 9.74555 14.1134 9.97547 13.9845 10.0966Z"
            fill="#0B5184"
          />
          <path
            d="M7.50047 10.8804C6.36422 10.8804 5.44336 11.4023 5.44336 11.9906C5.44336 12.0696 5.4607 12.2667 5.49281 12.2667H6.1868L6.32391 11.9383L6.44672 12.2667H9.49945C9.53648 12.2667 9.55711 12.0609 9.55711 11.9754C9.55711 11.3873 8.63648 10.8804 7.50047 10.8804Z"
            fill="#0B5184"
          />
          <path
            d="M7.51477 2.18644C8.06071 2.16562 8.60739 2.1747 9.15234 2.21362C9.69914 2.25347 10.2443 2.32776 10.803 2.41823C10.3059 2.14776 9.75937 1.9687 9.20062 1.86019C8.64117 1.74792 8.06789 1.7144 7.49883 1.72987C6.93187 1.75267 6.36815 1.82688 5.81461 1.95159C5.26148 2.06995 4.73156 2.24972 4.19531 2.41823C4.76461 2.43581 5.32125 2.35144 5.87109 2.30245C6.42211 2.25089 6.96844 2.2005 7.51477 2.18644Z"
            fill="#0B5184"
          />
          <path
            d="M7.51203 3.14948C8.17772 3.12863 8.84401 3.13754 9.50891 3.1762C10.1755 3.21605 10.8404 3.28988 11.5159 3.38152C10.8913 3.10659 10.2245 2.92917 9.54805 2.82136C8.87117 2.71003 8.18328 2.67722 7.49891 2.69269C6.81589 2.71521 6.13553 2.78909 5.46359 2.9137C4.79234 3.03136 4.14008 3.21206 3.48242 3.38128C4.16727 3.39909 4.84156 3.31542 5.51047 3.26597C6.18008 3.21417 6.84594 3.16378 7.51203 3.14948Z"
            fill="#0B5184"
          />
          <path
            d="M10.1859 6.5935C9.80341 6.59316 9.42914 6.70473 9.10923 6.91445C8.78931 7.12417 8.53773 7.42289 8.38547 7.77381C7.75945 7.74029 7.1707 7.76982 6.63563 7.82771C6.49047 7.46329 6.23928 7.15082 5.91457 6.93074C5.58985 6.71066 5.20656 6.5931 4.8143 6.59326C3.73195 6.59326 2.85352 7.46842 2.85352 8.54912C2.85352 9.62912 3.73195 10.5052 4.8143 10.5052C5.89688 10.5052 6.77555 9.62936 6.77555 8.54912C6.77555 8.52264 6.77227 8.49615 6.77133 8.46943C7.22367 8.42326 7.71398 8.39912 8.23125 8.41951C8.22773 8.4624 8.22422 8.50506 8.22422 8.54912C8.22422 9.62912 9.10266 10.5052 10.1857 10.5052C11.2678 10.5052 12.146 9.62936 12.146 8.54912C12.1463 7.46865 11.268 6.5935 10.1859 6.5935ZM4.8143 9.85295C4.09242 9.85295 3.50719 9.26959 3.50719 8.54912C3.50719 7.82865 4.09242 7.24506 4.8143 7.24506C5.53617 7.24506 6.12164 7.82865 6.12164 8.54912C6.12164 9.26959 5.53617 9.85295 4.8143 9.85295ZM10.1855 9.85295C9.46359 9.85295 8.87813 9.26959 8.87813 8.54912C8.87813 7.82865 9.46359 7.24506 10.1855 7.24506C10.9073 7.24506 11.4928 7.82865 11.4928 8.54912C11.4928 9.26959 10.9073 9.85295 10.1855 9.85295Z"
            fill="#0B5184"
          />
        </g>
        <defs>
          <clipPath id="clip0_128_599">
            <rect width="15" height="15" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (name === Icons.Insurance) {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_373_958)">
          <path
            d="M8 0C8.13261 0 8.25979 0.0526784 8.35355 0.146447C8.44732 0.240215 8.5 0.367392 8.5 0.5V1.014C12.625 1.238 16 4.22 16 8C16 8 16 8.5 15.5 8.5C15.351 8.5 15.148 8.355 15.148 8.355L15.144 8.351L15.119 8.328C14.9473 8.17887 14.7614 8.0469 14.564 7.934C14.0892 7.65589 13.5502 7.5063 13 7.5C12.362 7.5 11.822 7.713 11.436 7.934C11.2386 8.0469 11.0527 8.17887 10.881 8.328L10.856 8.351L10.853 8.354C10.853 8.354 10.649 8.5 10.5 8.5C10.351 8.5 10.148 8.355 10.148 8.355L10.144 8.351L10.119 8.328C9.9473 8.17887 9.76142 8.0469 9.564 7.934C9.23448 7.74362 8.8745 7.61168 8.5 7.544V13.5H8H8.5V13.539L8.495 13.622C8.46816 14.0052 8.36695 14.3795 8.197 14.724C8.02404 15.079 7.76094 15.3825 7.434 15.604C7.06 15.851 6.587 16 6 16C5.413 16 4.939 15.852 4.566 15.604C4.23899 15.3825 3.97588 15.0791 3.803 14.724C3.62089 14.3543 3.51803 13.9507 3.501 13.539V13.514L3.5 13.505V13.502C3.5 13.502 3.5 13.5 4 13.5H3.5V13C3.5 12.8674 3.55268 12.7402 3.64645 12.6464C3.74021 12.5527 3.86739 12.5 4 12.5C4.13261 12.5 4.25979 12.5527 4.35355 12.6464C4.44732 12.7402 4.5 12.8674 4.5 13V13.506L4.503 13.55C4.5205 13.8023 4.58672 14.0489 4.698 14.276C4.793 14.467 4.928 14.643 5.121 14.771C5.311 14.898 5.587 15 6 15C6.413 15 6.689 14.898 6.879 14.771C7.072 14.643 7.207 14.467 7.303 14.276C7.42062 14.0355 7.48767 13.7734 7.5 13.506V7.544C7.1255 7.61168 6.76553 7.74362 6.436 7.934C6.22888 8.05275 6.03453 8.19248 5.856 8.351L5.852 8.355C5.852 8.355 5.65 8.5 5.5 8.5C5.351 8.5 5.148 8.355 5.148 8.355L5.144 8.351C4.96547 8.19248 4.77112 8.05275 4.564 7.934C4.08924 7.65589 3.55019 7.5063 3 7.5C2.362 7.5 1.823 7.713 1.436 7.934C1.22888 8.05275 1.03453 8.19248 0.856 8.351L0.852 8.355C0.852 8.355 0.65 8.5 0.5 8.5C0 8.5 0 8 0 8C0 4.22 3.375 1.238 7.5 1.014V0.5C7.5 0.367392 7.55268 0.240215 7.64645 0.146447C7.74021 0.0526784 7.86739 0 8 0V0ZM6.577 2.123C3.744 2.623 1.587 4.581 1.103 6.977C1.68793 6.66817 2.33856 6.50457 3 6.5C3.806 6.5 4.48 6.75 4.962 7.011C4.97938 6.21385 5.09492 5.42189 5.306 4.653C5.548 3.785 5.946 2.888 6.577 2.123ZM5.962 7.053C6.58246 6.69644 7.28441 6.50597 8 6.5C8.71559 6.50597 9.41754 6.69644 10.038 7.053C10.0243 6.33302 9.92121 5.61753 9.731 4.923C9.434 3.858 8.898 2.83 8 2.117C7.102 2.829 6.566 3.857 6.269 4.921C6.0787 5.61585 5.97557 6.33168 5.962 7.052V7.053ZM9.422 2.123C10.053 2.888 10.452 3.785 10.694 4.653C10.927 5.486 11.022 6.313 11.038 7.011C11.6395 6.68069 12.3138 6.50509 13 6.5C13.77 6.5 14.42 6.73 14.897 6.977C14.413 4.581 12.256 2.622 9.423 2.123H9.422Z"
            fill="#5618BC"
          />
        </g>
        <defs>
          <clipPath id="clip0_373_958">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (name === Icons.MoreMenu) {
    return (
      <svg
        width="26"
        height="5"
        viewBox="0 0 26 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 0C11.6193 0 10.5 1.11929 10.5 2.5C10.5 3.88071 11.6193 5 13 5C14.3807 5 15.5 3.88071 15.5 2.5C15.5 1.11929 14.3807 0 13 0Z"
          fill="#353535"
        />
        <path
          d="M23 0C21.6193 0 20.5 1.11929 20.5 2.5C20.5 3.88071 21.6193 5 23 5C24.3807 5 25.5 3.88071 25.5 2.5C25.5 1.11929 24.3807 0 23 0Z"
          fill="#353535"
        />
        <path
          d="M3 0C1.61929 0 0.5 1.11929 0.5 2.5C0.5 3.88071 1.61929 5 3 5C4.38071 5 5.5 3.88071 5.5 2.5C5.5 1.11929 4.38071 0 3 0Z"
          fill="#353535"
        />
      </svg>
    );
  }
  if (name === Icons.ArrowDownCircle) {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.3059 8.1121L9.99956 12.097L5.69322 8.1121C5.61628 8.04076 5.513 8.00082 5.40545 8.00082C5.29789 8.00082 5.19461 8.04076 5.11767 8.1121C5.08041 8.14675 5.05082 8.18811 5.03061 8.23375C5.01041 8.2794 5 8.32841 5 8.37793C5 8.42744 5.01041 8.47645 5.03061 8.5221C5.05082 8.56774 5.08041 8.6091 5.11767 8.64375L9.69886 12.8839C9.77931 12.9583 9.88721 13 9.99956 13C10.1119 13 10.2198 12.9583 10.3003 12.8839L14.8815 8.64457C14.919 8.60989 14.9488 8.56843 14.9691 8.52264C14.9895 8.47684 15 8.42763 15 8.37793C15 8.32822 14.9895 8.27901 14.9691 8.23322C14.9488 8.18742 14.919 8.14596 14.8815 8.11128C14.8045 8.03994 14.7012 8 14.5937 8C14.4861 8 14.3828 8.03994 14.3059 8.11128V8.1121Z"
          fill="#FF6600"
        />
        <rect
          x="0.5"
          y="0.5"
          width="19"
          height="19"
          rx="9.5"
          stroke="#FF6600"
        />
      </svg>
    );
  }
  if (name === Icons.Filter) {
    return (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.646696 2.32547H2.90536C2.98297 2.78978 3.2143 3.21054 3.55867 3.51373C3.90303 3.81693 4.33837 3.98315 4.78812 3.98315C5.23787 3.98315 5.67321 3.81693 6.01757 3.51373C6.36194 3.21054 6.59327 2.78978 6.67087 2.32547H13.3895C13.474 2.32547 13.5551 2.29029 13.6148 2.22767C13.6745 2.16506 13.7081 2.08013 13.7081 1.99158C13.7081 1.90302 13.6745 1.81809 13.6148 1.75548C13.5551 1.69286 13.474 1.65768 13.3895 1.65768H6.67087C6.59327 1.19337 6.36194 0.772613 6.01757 0.469415C5.67321 0.166217 5.23787 0 4.78812 0C4.33837 0 3.90303 0.166217 3.55867 0.469415C3.2143 0.772613 2.98297 1.19337 2.90536 1.65768H0.646696C0.562206 1.65768 0.481176 1.69286 0.421432 1.75548C0.361689 1.81809 0.328125 1.90302 0.328125 1.99158C0.328125 2.08013 0.361689 2.16506 0.421432 2.22767C0.481176 2.29029 0.562206 2.32547 0.646696 2.32547ZM4.78812 0.655995C5.04015 0.655995 5.28652 0.734325 5.49607 0.881081C5.70563 1.02784 5.86896 1.23643 5.9654 1.48047C6.06185 1.72452 6.08709 1.99306 6.03792 2.25213C5.98875 2.51121 5.86739 2.74919 5.68917 2.93597C5.51096 3.12276 5.28391 3.24996 5.03672 3.30149C4.78953 3.35303 4.53332 3.32658 4.30047 3.22549C4.06763 3.1244 3.86861 2.95322 3.72859 2.73358C3.58857 2.51395 3.51384 2.25573 3.51384 1.99158C3.51384 1.63736 3.64809 1.29765 3.88706 1.04718C4.12604 0.796707 4.45016 0.655995 4.78812 0.655995ZM13.3895 6.66611H11.1309C11.0533 6.2018 10.8219 5.78104 10.4776 5.47784C10.1332 5.17464 9.69786 5.00843 9.24811 5.00843C8.79837 5.00843 8.36302 5.17464 8.01866 5.47784C7.67429 5.78104 7.44296 6.2018 7.36536 6.66611H0.646696C0.562206 6.66611 0.481176 6.70128 0.421432 6.7639C0.361689 6.82652 0.328125 6.91145 0.328125 7C0.328125 7.08855 0.361689 7.17348 0.421432 7.2361C0.481176 7.29872 0.562206 7.3339 0.646696 7.3339H7.36536C7.44296 7.7982 7.67429 8.21896 8.01866 8.52216C8.36302 8.82536 8.79837 8.99158 9.24811 8.99158C9.69786 8.99158 10.1332 8.82536 10.4776 8.52216C10.8219 8.21896 11.0533 7.7982 11.1309 7.3339H13.3895C13.474 7.3339 13.5551 7.29872 13.6148 7.2361C13.6745 7.17348 13.7081 7.08855 13.7081 7C13.7081 6.91145 13.6745 6.82652 13.6148 6.7639C13.5551 6.70128 13.474 6.66611 13.3895 6.66611ZM9.24811 8.33558C8.99608 8.33558 8.74971 8.25725 8.54016 8.11049C8.3306 7.96374 8.16728 7.75515 8.07083 7.5111C7.97438 7.26706 7.94915 6.99852 7.99831 6.73944C8.04748 6.48036 8.16885 6.24239 8.34706 6.0556C8.52527 5.86882 8.75233 5.74162 8.99951 5.69008C9.2467 5.63855 9.50292 5.665 9.73576 5.76609C9.96861 5.86717 10.1676 6.03836 10.3076 6.25799C10.4477 6.47763 10.5224 6.73585 10.5224 7C10.5224 7.35422 10.3881 7.69393 10.1492 7.9444C9.91019 8.19487 9.58607 8.33558 9.24811 8.33558ZM13.3895 11.6745H6.67087C6.59327 11.2102 6.36194 10.7895 6.01757 10.4863C5.67321 10.1831 5.23787 10.0169 4.78812 10.0169C4.33837 10.0169 3.90303 10.1831 3.55867 10.4863C3.2143 10.7895 2.98297 11.2102 2.90536 11.6745H0.646696C0.562206 11.6745 0.481176 11.7097 0.421432 11.7723C0.361689 11.8349 0.328125 11.9199 0.328125 12.0084C0.328125 12.097 0.361689 12.1819 0.421432 12.2445C0.481176 12.3071 0.562206 12.3423 0.646696 12.3423H2.90536C2.98297 12.8066 3.2143 13.2274 3.55867 13.5306C3.90303 13.8338 4.33837 14 4.78812 14C5.23787 14 5.67321 13.8338 6.01757 13.5306C6.36194 13.2274 6.59327 12.8066 6.67087 12.3423H13.3895C13.474 12.3423 13.5551 12.3071 13.6148 12.2445C13.6745 12.1819 13.7081 12.097 13.7081 12.0084C13.7081 11.9199 13.6745 11.8349 13.6148 11.7723C13.5551 11.7097 13.474 11.6745 13.3895 11.6745ZM4.78812 13.344C4.53609 13.344 4.28972 13.2657 4.08017 13.1189C3.87061 12.9722 3.70728 12.7636 3.61083 12.5195C3.51439 12.2755 3.48915 12.0069 3.53832 11.7479C3.58749 11.4888 3.70885 11.2508 3.88706 11.064C4.06528 10.8772 4.29233 10.75 4.53952 10.6985C4.78671 10.647 5.04292 10.6734 5.27577 10.7745C5.50861 10.8756 5.70763 11.0468 5.84765 11.2664C5.98767 11.4861 6.0624 11.7443 6.0624 12.0084C6.0624 12.3626 5.92815 12.7024 5.68917 12.9528C5.4502 13.2033 5.12608 13.344 4.78812 13.344Z"
          fill={fill || '#737373'}
        />
      </svg>
    );
  }
  if (name === Icons.Export) {
    return (
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.3805 5.75073H11.5239V6.45907H17.6587V17.0841H1.78034V6.45907H7.91517V5.75073H1.05859V17.7924H18.3805V5.75073Z"
          fill="#7F8B94"
          stroke="#7F8B94"
        />
        <path
          d="M10.0801 12.1258V2.35575L11.6293 3.87619L12.1396 3.3754L9.7192 1L7.29883 3.3754L7.8091 3.87619L9.35833 2.35575V12.1258H10.0801Z"
          fill="#7F8B94"
          stroke="#7F8B94"
        />
      </svg>
    );
  }
  if (name === Icons.Print) {
    return (
      <svg
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.7612 5H15.7753V0H3.94382V5H2.95787C1.32118 5 0 6.34 0 8V14H3.94382V18H15.7753V14H19.7191V8C19.7191 6.34 18.3979 5 16.7612 5ZM5.91573 2H13.8034V5H5.91573V2ZM13.8034 14V16H5.91573V12H13.8034V14ZM15.7753 12V10H3.94382V12H1.97191V8C1.97191 7.45 2.41559 7 2.95787 7H16.7612C17.3035 7 17.7472 7.45 17.7472 8V12H15.7753Z"
          fill={fill || '#7F8B94'}
        />
        <path
          d="M15.775 9.5C16.3195 9.5 16.761 9.05228 16.761 8.5C16.761 7.94772 16.3195 7.5 15.775 7.5C15.2305 7.5 14.7891 7.94772 14.7891 8.5C14.7891 9.05228 15.2305 9.5 15.775 9.5Z"
          fill={fill || '#7F8B94'}
        />
      </svg>
    );
  }
  if (name === Icons.ArrowUpCircle) {
    return (
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_588_5380)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.70927 8.04038C9.28978 6.37209 11.4683 5.39999 13.7655 5.33793C16.0628 5.27586 18.2906 6.12892 19.9589 7.70943C21.6272 9.28994 22.5993 11.4684 22.6613 13.7657C22.7234 16.0629 21.8703 18.2907 20.2898 19.959C18.7093 21.6273 16.5308 22.5994 14.2336 22.6615C11.9363 22.7235 9.7085 21.8705 8.04022 20.29C6.37193 18.7095 5.39983 16.531 5.33777 14.2337C5.2757 11.9365 6.12876 9.70866 7.70927 8.04038ZM21.1884 20.8104C22.9947 18.9038 23.9696 16.3577 23.8987 13.7323C23.8278 11.1068 22.7168 8.61712 20.8102 6.81082C18.9036 5.00452 16.3575 4.0296 13.7321 4.10053C11.1067 4.17146 8.61696 5.28243 6.81066 7.18904C5.00436 9.09566 4.02944 11.6417 4.10037 14.2671C4.1713 16.8926 5.28227 19.3823 7.18889 21.1886C9.0955 22.9949 11.6416 23.9698 14.267 23.8989C16.8924 23.8279 19.3821 22.717 21.1884 20.8104ZM13.4533 18.3487C13.4579 18.5129 13.5275 18.6686 13.6468 18.7814C13.7661 18.8943 13.9253 18.9552 14.0895 18.9506C14.2537 18.946 14.4093 18.8765 14.5222 18.7572C14.6351 18.6378 14.6959 18.4786 14.6914 18.3144L14.4977 11.1466L16.9851 13.5031C17.1043 13.616 17.2634 13.677 17.4275 13.6725C17.5916 13.6681 17.7472 13.5987 17.8601 13.4795C17.973 13.3603 18.0339 13.2012 18.0295 13.0371C18.025 12.873 17.9556 12.7174 17.8364 12.6045L14.2644 9.22047C14.1453 9.10758 13.9862 9.04665 13.8221 9.05108C13.658 9.05551 13.5024 9.12495 13.3895 9.24411L10.0054 12.8161C9.89254 12.9353 9.8316 13.0944 9.83604 13.2585C9.84047 13.4226 9.90991 13.5782 10.0291 13.6911C10.1482 13.804 10.3074 13.8649 10.4715 13.8605C10.6355 13.856 10.7911 13.7866 10.904 13.6674L13.2605 11.1801L13.4533 18.3487Z"
            fill="#7A7C87"
          />
        </g>
        <defs>
          <clipPath id="clip0_588_5380">
            <rect
              width="19.8056"
              height="19.8056"
              fill="white"
              transform="matrix(0.725946 0.687752 0.687752 -0.725946 0 14.3779)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (name === Icons.SelectDropdown) {
    return (
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="11.5" cy="11.5" r="11.5" fill="#FF6606" />
        <path d="M11 16L17.0622 10H4.93782L11 16Z" fill="white" />
      </svg>
    );
  }
  if (name === Icons.Edit) {
    return (
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.30273 7.69747H5.92605L12.0002 1.62332L10.3769 0L4.30273 6.07415V7.69747ZM11.2845 1.62332L10.3769 2.5309L9.46931 1.62332L10.3769 0.715738L11.2845 1.62332ZM4.80891 6.28371L9.11144 1.98119L10.019 2.88877L5.71649 7.19129H4.80891V6.28371Z"
          fill="#FF7A00"
        />
        <path
          d="M10.6298 4.66028H10.1236V11.4937H0.50618V1.8763H7.59269V1.37012H0V11.9999H10.6298V4.66028Z"
          fill="#FF7A00"
        />
      </svg>
    );
  }
  if (name === Icons.Close) {
    return (
      <svg
        width={width || '25'}
        height={height || '25'}
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 1.5625C15.4008 1.5625 18.1828 2.71484 20.234 4.76602C22.2852 6.8172 23.4375 9.59919 23.4375 12.5C23.4375 15.4008 22.2852 18.1828 20.234 20.234C18.1828 22.2852 15.4008 23.4375 12.5 23.4375C9.59919 23.4375 6.8172 22.2852 4.76602 20.234C2.71484 18.1828 1.5625 15.4008 1.5625 12.5C1.5625 9.59919 2.71484 6.8172 4.76602 4.76602C6.8172 2.71484 9.59919 1.5625 12.5 1.5625ZM12.5 11.1734L9.95938 8.63281C9.78346 8.4569 9.54487 8.35807 9.29609 8.35807C9.04732 8.35807 8.80873 8.4569 8.63281 8.63281C8.4569 8.80873 8.35807 9.04732 8.35807 9.29609C8.35807 9.54487 8.4569 9.78346 8.63281 9.95938L11.1734 12.5L8.63281 15.0406C8.54571 15.1277 8.47661 15.2311 8.42948 15.3449C8.38234 15.4587 8.35807 15.5807 8.35807 15.7039C8.35807 15.8271 8.38234 15.9491 8.42948 16.0629C8.47661 16.1767 8.54571 16.2801 8.63281 16.3672C8.71992 16.4543 8.82332 16.5234 8.93713 16.5705C9.05093 16.6177 9.17291 16.6419 9.29609 16.6419C9.41928 16.6419 9.54125 16.6177 9.65506 16.5705C9.76887 16.5234 9.87227 16.4543 9.95938 16.3672L12.5 13.8266L15.0406 16.3672C15.1277 16.4543 15.2311 16.5234 15.3449 16.5705C15.4587 16.6177 15.5807 16.6419 15.7039 16.6419C15.8271 16.6419 15.9491 16.6177 16.0629 16.5705C16.1767 16.5234 16.2801 16.4543 16.3672 16.3672C16.4543 16.2801 16.5234 16.1767 16.5705 16.0629C16.6177 15.9491 16.6419 15.8271 16.6419 15.7039C16.6419 15.5807 16.6177 15.4587 16.5705 15.3449C16.5234 15.2311 16.4543 15.1277 16.3672 15.0406L13.8266 12.5L16.3672 9.95938C16.4543 9.87227 16.5234 9.76887 16.5705 9.65506C16.6177 9.54125 16.6419 9.41928 16.6419 9.29609C16.6419 9.17291 16.6177 9.05093 16.5705 8.93713C16.5234 8.82332 16.4543 8.71992 16.3672 8.63281C16.2801 8.54571 16.1767 8.47661 16.0629 8.42948C15.9491 8.38234 15.8271 8.35807 15.7039 8.35807C15.5807 8.35807 15.4587 8.38234 15.3449 8.42948C15.2311 8.47661 15.1277 8.54571 15.0406 8.63281L12.5 11.1734Z"
          fill={fill || '#7F8B94'}
        />
      </svg>
    );
  }
  if (name === Icons.AddCircle) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1C5.925 1 1 5.925 1 12C1 18.075 5.925 23 12 23C18.075 23 23 18.075 23 12C23 5.925 18.075 1 12 1ZM13 16C13 16.2652 12.8946 16.5196 12.7071 16.7071C12.5196 16.8946 12.2652 17 12 17C11.7348 17 11.4804 16.8946 11.2929 16.7071C11.1054 16.5196 11 16.2652 11 16V13H8C7.73478 13 7.48043 12.8946 7.29289 12.7071C7.10536 12.5196 7 12.2652 7 12C7 11.7348 7.10536 11.4804 7.29289 11.2929C7.48043 11.1054 7.73478 11 8 11H11V8C11 7.73478 11.1054 7.48043 11.2929 7.29289C11.4804 7.10536 11.7348 7 12 7C12.2652 7 12.5196 7.10536 12.7071 7.29289C12.8946 7.48043 13 7.73478 13 8V11H16C16.2652 11 16.5196 11.1054 16.7071 11.2929C16.8946 11.4804 17 11.7348 17 12C17 12.2652 16.8946 12.5196 16.7071 12.7071C16.5196 12.8946 16.2652 13 16 13H13V16Z"
          fill="#C9CDDC"
        />
      </svg>
    );
  }
  if (name === Icons.Delete) {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.3125 7.5H21.5625V5.15625C21.5625 4.12207 20.7217 3.28125 19.6875 3.28125H10.3125C9.27832 3.28125 8.4375 4.12207 8.4375 5.15625V7.5H4.6875C4.16895 7.5 3.75 7.91895 3.75 8.4375V9.375C3.75 9.50391 3.85547 9.60938 3.98438 9.60938H5.75391L6.47754 24.9316C6.52441 25.9307 7.35059 26.7188 8.34961 26.7188H21.6504C22.6523 26.7188 23.4756 25.9336 23.5225 24.9316L24.2461 9.60938H26.0156C26.1445 9.60938 26.25 9.50391 26.25 9.375V8.4375C26.25 7.91895 25.8311 7.5 25.3125 7.5ZM19.4531 7.5H10.5469V5.39062H19.4531V7.5Z"
          fill="#FF6606"
        />
      </svg>
    );
  }
  if (name === Icons.Required) {
    return (
      <svg
        width="6"
        height="6"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.08688 4.3711C8.83469 4.3711 6.74045 4.61064 5.62969 4.74029C6.50644 4.04617 8.15637 2.7346 8.33583 2.55593C8.89714 1.99383 8.70266 1.63096 8.53664 1.46494C8.26152 1.18982 7.8607 1.2499 7.44565 1.66574C7.26697 1.84441 5.95541 3.49435 5.26128 4.3711C5.39015 3.26034 5.63048 1.1661 5.63048 0.913906C5.63048 0.118586 5.23599 0 5.00118 0C4.76638 0 4.37189 0.118586 4.37189 0.913906C4.37189 1.1661 4.61143 3.26113 4.74029 4.3711C4.04617 3.49435 2.7346 1.84441 2.55593 1.66574C2.14009 1.2499 1.74006 1.18982 1.46494 1.46494C1.29575 1.63412 1.25069 1.85548 1.33765 2.08791C1.39299 2.23575 1.50368 2.39307 1.66574 2.55593C1.84441 2.7346 3.49435 4.04538 4.3711 4.7395C3.26034 4.61064 1.1661 4.3703 0.913115 4.3703C0.118586 4.3711 0 4.76559 0 5.00039C0 5.2352 0.118586 5.62969 0.913115 5.62969C1.1661 5.62969 3.25954 5.39015 4.3703 5.26128C3.49356 5.95541 1.84362 7.26698 1.66495 7.44565C1.50288 7.60771 1.3922 7.76504 1.33686 7.91288C1.24911 8.1461 1.29496 8.36746 1.46415 8.53585C1.57641 8.64732 1.71318 8.70741 1.86023 8.70741C2.07526 8.70741 2.30848 8.58249 2.55514 8.33583C2.73381 8.15716 4.04538 6.50644 4.7395 5.62969C4.61064 6.74045 4.3711 8.83469 4.3711 9.08767C4.3711 9.8822 4.76559 10.0008 5.00039 10.0008C5.23519 10.0008 5.62969 9.8822 5.62969 9.08767C5.62969 8.83469 5.39015 6.74124 5.26049 5.63048C5.95462 6.50723 7.26618 8.15716 7.44485 8.33583C7.69151 8.58249 7.92552 8.70741 8.14056 8.70741C8.28761 8.70741 8.42438 8.64811 8.53585 8.53585C8.70187 8.36983 8.89714 8.00696 8.33504 7.44486C8.15637 7.26618 6.50644 5.95462 5.6289 5.26049C6.73966 5.38936 8.8339 5.6289 9.08609 5.6289C9.88141 5.6289 10 5.2352 10 4.9996C10.0008 4.76559 9.8822 4.3711 9.08688 4.3711Z"
          fill="#FF6600"
        />
      </svg>
    );
  }
  if (name === Icons.NationalID) {
    return (
      <svg
        width="41"
        height="34"
        viewBox="0 0 41 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M36.7292 34H4.27083C1.91607 34 0 32.067 0 29.6944V7.30556C0 4.93164 1.91607 3 4.27083 3H14.5208C14.9923 3 15.375 3.38578 15.375 3.86111C15.375 4.33644 14.9923 4.72222 14.5208 4.72222H4.27083C2.8577 4.72222 1.70833 5.88093 1.70833 7.30556V29.6944C1.70833 31.1191 2.8577 32.2778 4.27083 32.2778H36.7292C38.1423 32.2778 39.2917 31.1191 39.2917 29.6944V7.30556C39.2917 5.88093 38.1423 4.72222 36.7292 4.72222H26.4792C26.0077 4.72222 25.625 4.33644 25.625 3.86111C25.625 3.38578 26.0077 3 26.4792 3H36.7292C39.0826 3 41 4.93164 41 7.30556V29.6944C41 32.067 39.0826 34 36.7292 34Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M13 20C10.7958 20 9 18.2042 9 16C9 13.7946 10.7958 12 13 12C15.2054 12 17 13.7946 17 16C17 18.2042 15.2054 20 13 20ZM13 13.6C11.6765 13.6 10.6 14.6765 10.6 16C10.6 17.3235 11.6765 18.4 13 18.4C14.3235 18.4 15.4 17.3235 15.4 16C15.4 14.6765 14.3235 13.6 13 13.6Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M20.1111 29C19.6204 29 19.2222 28.608 19.2222 28.125V26.375C19.2222 24.9274 18.0261 23.75 16.5556 23.75H9.44444C7.97387 23.75 6.77778 24.9274 6.77778 26.375V28.125C6.77778 28.608 6.37956 29 5.88889 29C5.39822 29 5 28.608 5 28.125V26.375C5 23.9628 6.99396 22 9.44444 22H16.5556C19.0046 22 21 23.9628 21 26.375V28.125C21 28.608 20.6018 29 20.1111 29Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M35.1429 15H24.8571C24.384 15 24 14.552 24 14C24 13.448 24.384 13 24.8571 13H35.1429C35.616 13 36 13.448 36 14C36 14.552 35.616 15 35.1429 15Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M35.1429 22H24.8571C24.384 22 24 21.552 24 21C24 20.448 24.384 20 24.8571 20H35.1429C35.616 20 36 20.448 36 21C36 21.552 35.616 22 35.1429 22Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M35.1429 29H24.8571C24.384 29 24 28.552 24 28C24 27.448 24.384 27 24.8571 27H35.1429C35.616 27 36 27.448 36 28C36 28.552 35.616 29 35.1429 29Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M24.5625 8H16.4375C15.0933 8 14 6.92352 14 5.6V2.4C14 1.07648 15.0933 0 16.4375 0H24.5625C25.9067 0 27 1.07648 27 2.4V5.6C27 6.92352 25.9067 8 24.5625 8ZM16.4375 1.6C15.989 1.6 15.625 1.9584 15.625 2.4V5.6C15.625 6.0416 15.989 6.4 16.4375 6.4H24.5625C25.011 6.4 25.375 6.0416 25.375 5.6V2.4C25.375 1.9584 25.011 1.6 24.5625 1.6H16.4375Z"
          fill={fill || '#FF6606'}
        />
      </svg>
    );
  }
  if (name === Icons.Passport) {
    return (
      <svg
        width="25"
        height="39"
        viewBox="0 0 25 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.1496 5.4858H20.9957V0.47619C20.9957 0.213737 20.7798 0 20.516 0C20.4682 0 20.419 0.00814948 20.3793 0.0162666L1.75343 5.4858C0.769446 5.54127 0 6.34084 0 7.31625V37.1696C0 38.1842 0.83229 39 1.85044 39H23.1496C24.1745 39 25 38.1761 25 37.1696V7.31625C25 6.30161 24.1677 5.4858 23.1496 5.4858ZM20.0349 1.10935V5.47771H5.14134L20.0349 1.10935ZM24.0392 37.1696C24.0392 37.6525 23.6388 38.0489 23.1496 38.0489H1.85044C1.36118 38.0489 0.960752 37.6525 0.960752 37.1696V7.31625C0.960752 6.99968 1.12888 6.71421 1.40084 6.55593L1.40901 6.57888L1.89823 6.43686H23.1496C23.6388 6.43686 24.0392 6.83328 24.0392 7.31625V37.1696Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M19.5128 29H5.48707C5.21862 29 5 29.2248 5 29.4993C5 29.7753 5.21862 30 5.48707 30H19.5128C19.7813 30 20 29.7753 20 29.4993C20 29.2248 19.7813 29 19.5128 29Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M15.5379 33H9.4621C9.20741 33 9 33.2247 9 33.5007C9 33.7752 9.20741 34 9.4621 34H15.5379C15.7926 34 16 33.7752 16 33.5007C16 33.2247 15.7926 33 15.5379 33Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M12.5 12C8.36376 12 5 15.1316 5 19C5 22.8685 8.35526 26 12.5 26C16.6448 26 20 22.8685 20 19C19.9915 15.1316 16.6363 12 12.5 12ZM10.2249 13.3177C9.60969 13.9144 9.11923 14.605 8.77053 15.3644C8.46293 15.1633 8.18089 14.9463 7.91582 14.6976C8.57212 14.0851 9.36021 13.6206 10.2249 13.3177ZM7.26797 15.4028C7.62519 15.7216 8.00653 16.0154 8.42186 16.2641C8.18939 16.9997 8.05614 17.767 8.02353 18.5344H6.02203C6.11275 17.3952 6.54505 16.3183 7.26797 15.4028ZM6.02203 19.4578H8.02353C8.05614 20.2252 8.18939 20.9925 8.42186 21.7294C8.00653 21.9768 7.62519 22.2639 7.26797 22.5894C6.54505 21.6752 6.11275 20.589 6.02203 19.4578ZM7.9243 23.2945C8.18937 23.0471 8.47149 22.8301 8.77909 22.6277C9.1278 23.3871 9.6182 24.0777 10.232 24.6744C9.36022 24.3728 8.5721 23.8991 7.9243 23.2945ZM12.0011 24.8292C10.955 24.2246 10.1498 23.2945 9.64236 22.1474C10.3823 21.8061 11.1874 21.605 12.0011 21.5508V24.8292ZM12.0011 20.6207C11.0712 20.6749 10.1583 20.8999 9.31913 21.2637C9.15329 20.675 9.05265 20.0704 9.02004 19.4578H12.0011V20.6207ZM12.0011 18.5277H9.02004C9.05265 17.9152 9.15329 17.3105 9.31913 16.7205C10.1668 17.0936 11.0712 17.3105 12.0011 17.3648V18.5277ZM12.0011 16.4347C11.1789 16.3805 10.3823 16.1701 9.64236 15.8367C10.1583 14.6897 10.9635 13.7676 12.0011 13.163V16.4347ZM17.0843 14.6976C16.8192 14.9463 16.5371 15.17 16.2295 15.3644C15.8808 14.605 15.3903 13.9064 14.7751 13.3098C15.6398 13.6207 16.4294 14.093 17.0843 14.6976ZM12.999 13.163C14.0451 13.7755 14.8502 14.6976 15.3662 15.8447C14.6263 16.186 13.8211 16.3871 12.999 16.4413V13.163ZM12.999 17.3727C13.9289 17.3184 14.8418 17.1002 15.6894 16.7284C15.8553 17.3184 15.9559 17.9231 15.9885 18.5277H12.999V17.3727ZM12.999 19.4578H15.98C15.9474 20.0624 15.8552 20.667 15.6809 21.2557C14.8346 20.8839 13.9204 20.667 12.9905 20.6128V19.4578H12.999ZM12.999 24.8292V21.5508C13.8211 21.605 14.6263 21.8061 15.3662 22.1474C14.8502 23.2945 14.0451 24.2246 12.999 24.8292ZM14.7751 24.6744C15.3903 24.0777 15.8808 23.3805 16.2295 22.6197C16.5371 22.8222 16.8192 23.0471 17.0843 23.2866C16.4294 23.8991 15.6398 24.3728 14.7751 24.6744ZM17.732 22.5894C17.3833 22.2639 16.9936 21.9768 16.5782 21.7294C16.8107 20.9925 16.9439 20.2331 16.9765 19.4657H18.9781C18.8873 20.589 18.455 21.6752 17.732 22.5894ZM16.9765 18.5277C16.9439 17.7604 16.8107 16.9997 16.5782 16.2641C16.9936 16.0154 17.3748 15.7216 17.732 15.4028C18.455 16.3183 18.8873 17.3952 18.9781 18.5277H16.9765Z"
          fill={fill || '#FF6606'}
        />
      </svg>
    );
  }
  if (name === Icons.DriverLicense) {
    return (
      <svg
        width="40"
        height="27"
        viewBox="0 0 40 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M37.656 0H2.34399C1.05199 0 0 1.06931 0 2.38259V24.6174C0 25.9307 1.05199 27 2.34399 27H37.656C38.9493 27 40 25.9307 40 24.6174V2.38259C40 1.06931 38.9493 0 37.656 0ZM38.4373 24.6174C38.4373 25.0552 38.0867 25.4116 37.656 25.4116H2.34399C1.91333 25.4116 1.56266 25.0552 1.56266 24.6174V2.38259C1.56266 1.94483 1.91333 1.58839 2.34399 1.58839H37.656C38.0867 1.58839 38.4373 1.94483 38.4373 2.38259V24.6174Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M36.2129 3H3.78713C3.35193 3 3 3.36116 3 3.8078V23.1922C3 23.6388 3.35193 24 3.78713 24H16.4592C16.8931 24 17.245 23.6388 17.245 23.1922C17.245 22.747 16.8931 22.3844 16.4592 22.3844H4.57427V4.61559H35.4257V22.3844H23.5421C23.1069 22.3844 22.755 22.747 22.755 23.1922C22.755 23.6388 23.1069 24 23.5421 24H36.2129C36.6481 24 37 23.6388 37 23.1922V3.8078C37 3.36116 36.6481 3 36.2129 3Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M6 16.1053V17.2142C6 17.6473 6.33872 18 6.75627 18H14.2425C14.6613 18 15 17.6473 15 17.2142V16.1053C15 14.59 14.3045 13.2047 13.1449 12.333C13.3065 11.9589 13.3957 11.5473 13.3957 11.1128V10.0038C13.3957 8.34766 12.0965 7 10.5 7C8.90219 7 7.60297 8.34766 7.60297 10.0038V11.1128C7.60297 11.5473 7.6935 11.9589 7.8538 12.3317C6.69422 13.2034 6 14.59 6 16.1053ZM9.11804 10.0038C9.11804 9.21393 9.73858 8.57031 10.5 8.57031C11.2614 8.57031 11.8806 9.21393 11.8806 10.0038V11.1128C11.8806 11.9026 11.2614 12.5462 10.5 12.5462C9.73858 12.5462 9.11804 11.9026 9.11804 11.1128V10.0038ZM7.51381 16.1053C7.51381 15.0888 8.01407 14.1286 8.81427 13.5534C9.28999 13.9074 9.87174 14.1165 10.5 14.1165C11.1283 14.1165 11.71 13.9074 12.1857 13.5534C12.9963 14.1286 13.4849 15.0727 13.4849 16.1053V16.4284H7.51381V16.1053Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M6.75627 21H14.2425C14.6613 21 15 20.5525 15 20.0008C15 19.4475 14.6613 19 14.2425 19H6.75627C6.33872 19 6 19.4475 6 20.0008C6 20.5525 6.33872 21 6.75627 21Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M19.8066 8H33.1948C33.6394 8 34 7.77626 34 7.49958C34 7.22376 33.6394 7 33.1948 7H19.8066C19.3606 7 19 7.22376 19 7.49958C19 7.77626 19.3606 8 19.8066 8Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M19.8066 15H33.1948C33.6394 15 34 14.5529 34 14C34 13.4471 33.6394 13 33.1948 13H19.8066C19.3606 13 19 13.4471 19 14C19 14.5529 19.3606 15 19.8066 15Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M19.8066 18H33.1948C33.6394 18 34 17.5512 34 17C34 16.4471 33.6394 16 33.1948 16H19.8066C19.3606 16 19 16.4471 19 17C19 17.5512 19.3606 18 19.8066 18Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M33.2245 19H26.7768C26.3486 19 26 19.4475 26 20.0008C26 20.5525 26.3486 21 26.7768 21H33.2245C33.6527 21 34 20.5525 34 20.0008C34 19.4475 33.6527 19 33.2245 19Z"
          fill={fill || '#FF6606'}
        />
        <path
          d="M20 23C19.4471 23 19 23.2244 19 23.5C19 23.7765 19.4488 24 20 24C20.5529 24 21 23.7765 21 23.5C21 23.2244 20.5529 23 20 23Z"
          fill={fill || '#FF6606'}
        />
      </svg>
    );
  }
  if (name === Icons.VotersCard) {
    return (
      <svg
        width="41"
        height="33"
        viewBox="0 0 41 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M31.991 28.1905H4.20385C3.87175 28.1905 3.60393 28.4586 3.60393 28.7911C3.60393 29.1236 3.87175 29.3932 4.20385 29.3932H31.991C32.3231 29.3932 32.5923 29.1236 32.5923 28.7911C32.5923 28.4586 32.3231 28.1905 31.991 28.1905ZM31.991 25.7851H4.20385C3.87175 25.7851 3.60393 26.0546 3.60393 26.3857C3.60393 26.7182 3.87175 26.9878 4.20385 26.9878H31.991C32.3231 26.9878 32.5923 26.7182 32.5923 26.3857C32.5923 26.0546 32.3231 25.7851 31.991 25.7851ZM35.5948 17.9476C35.2627 17.9476 34.9935 18.2172 34.9935 18.5497V29.9939C34.9935 30.9886 34.1858 31.7973 33.1922 31.7973H3.0026C2.00903 31.7973 1.20134 30.9886 1.20134 29.9939V10.7834C1.20134 9.78866 2.00903 8.97861 3.0026 8.97861H21.7682C22.1003 8.97861 22.3696 8.7091 22.3696 8.37798C22.3696 8.04549 22.1003 7.77594 21.7682 7.77594H3.0026C1.34756 7.77594 0 9.12505 0 10.7834V29.9939C0 31.6522 1.34756 33 3.0026 33H33.1922C34.8486 33 36.1948 31.6522 36.1948 29.9939V18.5497C36.1948 18.2172 35.9269 17.9476 35.5948 17.9476ZM32.2847 0C27.4795 0 23.5709 3.9133 23.5709 8.72414C23.5709 9.65183 23.7157 10.5453 23.985 11.384H19.8194C19.4873 11.384 19.2181 11.6536 19.2181 11.9861C19.2181 12.3172 19.4873 12.5868 19.8194 12.5868H24.4729C24.6806 13.0082 24.9226 13.4104 25.1932 13.7894H19.8194C19.4873 13.7894 19.2181 14.059 19.2181 14.3901C19.2181 14.7226 19.4873 14.9922 19.8194 14.9922H26.2291C27.798 16.5123 29.9341 17.4495 32.2847 17.4495C37.0899 17.4495 41 13.535 41 8.72414C41 3.9133 37.0899 0 32.2847 0ZM32.2847 16.2469C28.1424 16.2469 24.7722 12.8727 24.7722 8.72414C24.7722 4.57692 28.1424 1.20275 32.2847 1.20275C36.4285 1.20275 39.7987 4.57692 39.7987 8.72414C39.7987 12.8727 36.4285 16.2469 32.2847 16.2469ZM5.79057 24.4688C5.9737 24.5194 6.25385 24.5741 6.60645 24.5823H13.7829C15.3108 24.6124 16.8182 23.2456 16.7868 21.5763V14.3901C16.7868 12.7332 15.4393 11.384 13.7829 11.384H6.60645C4.95005 11.384 3.60393 12.7332 3.60393 14.3901V21.5763C3.60393 22.9501 4.5305 24.1117 5.79057 24.4688ZM6.67893 23.3797C7.1559 21.8746 8.5745 20.8005 10.1954 20.8005C11.8162 20.8005 13.2335 21.8746 13.7118 23.3797H6.67893ZM7.89387 17.295C7.89387 16.0252 8.9271 14.9922 10.1954 14.9922C11.4636 14.9922 12.4954 16.0252 12.4954 17.295C12.4954 18.5647 11.4636 19.5977 10.1954 19.5977C8.9271 19.5977 7.89387 18.5647 7.89387 17.295ZM4.80519 14.3901C4.80519 13.3954 5.61288 12.5868 6.60645 12.5868H13.7829C14.7764 12.5868 15.5855 13.3954 15.5855 14.3901V21.5763C15.5855 22.1674 15.2985 22.6942 14.8584 23.0226C14.447 21.7241 13.5095 20.6664 12.3109 20.0849C13.1528 19.4445 13.6967 18.432 13.6967 17.295C13.6967 15.3616 12.1251 13.7894 10.1954 13.7894C8.26426 13.7894 6.69395 15.3616 6.69395 17.295C6.69395 18.432 7.23788 19.4445 8.07838 20.0849C6.88118 20.6664 5.94223 21.7241 5.53223 23.0226C5.0908 22.6942 4.80519 22.1674 4.80519 21.5763V14.3901ZM35.2818 6.61428L31.1163 10.7847C31.0575 10.8436 30.9632 10.8436 30.9044 10.7847L29.2877 9.16609C29.054 8.93212 28.6727 8.93212 28.439 9.16609C28.2039 9.40143 28.2039 9.78183 28.439 10.0172L30.0557 11.6358C30.3181 11.8985 30.6639 12.0312 31.011 12.0312C31.3568 12.0312 31.7025 11.8985 31.9649 11.6358L36.1319 7.46394C36.367 7.2286 36.367 6.84825 36.1319 6.61428C35.8969 6.37894 35.5169 6.37894 35.2818 6.61428ZM31.991 20.9743H19.8194C19.4873 20.9743 19.2181 21.2438 19.2181 21.5763C19.2181 21.9074 19.4873 22.1769 19.8194 22.1769H31.991C32.3231 22.1769 32.5923 21.9074 32.5923 21.5763C32.5923 21.2438 32.3231 20.9743 31.991 20.9743ZM31.991 23.3797H19.8194C19.4873 23.3797 19.2181 23.6492 19.2181 23.9817C19.2181 24.3128 19.4873 24.5823 19.8194 24.5823H31.991C32.3231 24.5823 32.5923 24.3128 32.5923 23.9817C32.5923 23.6492 32.3231 23.3797 31.991 23.3797Z"
          fill={fill || '#FF6606'}
        />
      </svg>
    );
  }
  if (name === Icons.BVN) {
    return (
      <svg
        width="43"
        height="43"
        viewBox="0 0 43 43"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.106 18.3105C20.8513 18.0731 20.5144 17.9439 20.1662 17.9501C19.8181 17.9562 19.486 18.0972 19.2398 18.3434C18.9936 18.5896 18.8525 18.9218 18.8464 19.2699C18.8402 19.618 18.9695 19.9549 19.2068 20.2097L20.4968 21.4997L19.2068 22.7897C19.0748 22.9127 18.9689 23.061 18.8955 23.2259C18.822 23.3907 18.7825 23.5686 18.7794 23.7491C18.7762 23.9295 18.8094 24.1087 18.8769 24.276C18.9445 24.4434 19.0451 24.5954 19.1727 24.723C19.3003 24.8506 19.4523 24.9511 19.6196 25.0187C19.787 25.0863 19.9662 25.1195 20.1466 25.1163C20.327 25.1131 20.505 25.0736 20.6698 25.0002C20.8346 24.9268 20.983 24.8209 21.106 24.6888L22.396 23.3988L23.686 24.6888C23.9383 24.9407 24.2803 25.082 24.6368 25.0816C24.9933 25.0813 25.3351 24.9394 25.587 24.6871C25.8388 24.4347 25.9801 24.0927 25.9798 23.7362C25.9794 23.3797 25.8375 23.0379 25.5852 22.7861L24.297 21.4997L25.587 20.2097C25.7152 20.0857 25.8175 19.9373 25.8879 19.7734C25.9582 19.6094 25.9952 19.433 25.9967 19.2546C25.9981 19.0762 25.9641 18.8993 25.8964 18.7342C25.8288 18.569 25.7289 18.4191 25.6027 18.293C25.4765 18.1668 25.3264 18.0671 25.1612 17.9997C24.996 17.9322 24.8191 17.8982 24.6407 17.8999C24.4622 17.9015 24.2859 17.9387 24.122 18.0092C23.9581 18.0797 23.8099 18.1821 23.686 18.3105L22.396 19.6005L21.106 18.3105ZM9.35266 18.3105C9.60462 18.0589 9.94615 17.9175 10.3022 17.9175C10.6583 17.9175 10.9999 18.0589 11.2518 18.3105L12.5418 19.6005L13.8318 18.3105C13.9548 18.1785 14.1032 18.0726 14.268 17.9992C14.4329 17.9257 14.6108 17.8862 14.7912 17.883C14.9717 17.8798 15.1509 17.913 15.3182 17.9806C15.4855 18.0482 15.6375 18.1488 15.7651 18.2764C15.8927 18.404 15.9933 18.556 16.0609 18.7233C16.1285 18.8906 16.1617 19.0699 16.1585 19.2503C16.1553 19.4307 16.1158 19.6086 16.0424 19.7735C15.9689 19.9383 15.863 20.0867 15.731 20.2097L14.4428 21.4997L15.7328 22.7861C15.8577 22.9109 15.9569 23.0591 16.0245 23.2222C16.0922 23.3854 16.127 23.5602 16.1271 23.7368C16.1272 23.9134 16.0925 24.0883 16.025 24.2515C15.9575 24.4147 15.8585 24.563 15.7337 24.6879C15.6089 24.8129 15.4607 24.912 15.2975 24.9797C15.1344 25.0473 14.9595 25.0822 14.7829 25.0823C14.6063 25.0824 14.4314 25.0477 14.2683 24.9802C14.1051 24.9126 13.9568 24.8137 13.8318 24.6888L12.5418 23.3988L11.2518 24.6888C10.9971 24.9262 10.6602 25.0554 10.3121 25.0493C9.96394 25.0431 9.63179 24.9021 9.38559 24.6559C9.13939 24.4097 8.99837 24.0776 8.99222 23.7294C8.98608 23.3813 9.1153 23.0444 9.35266 22.7897L10.6427 21.4997L9.35266 20.2097C9.10102 19.9577 8.95968 19.6162 8.95968 19.2601C8.95968 18.904 9.10102 18.5625 9.35266 18.3105ZM29.5627 24.1872C29.2063 24.1872 28.8645 24.3287 28.6125 24.5808C28.3605 24.8328 28.2189 25.1745 28.2189 25.5309C28.2189 25.8873 28.3605 26.2291 28.6125 26.4811C28.8645 26.7331 29.2063 26.8747 29.5627 26.8747H32.6981C33.0545 26.8747 33.3963 26.7331 33.6483 26.4811C33.9003 26.2291 34.0418 25.8873 34.0418 25.5309C34.0418 25.1745 33.9003 24.8328 33.6483 24.5808C33.3963 24.3287 33.0545 24.1872 32.6981 24.1872H29.5627ZM9.40641 8.95801C7.86208 8.95801 6.381 9.57149 5.28899 10.6635C4.19698 11.7555 3.5835 13.2366 3.5835 14.7809V28.2184C3.5835 29.7628 4.19698 31.2438 5.28899 32.3358C6.381 33.4279 7.86208 34.0413 9.40641 34.0413H33.5939C34.3586 34.0413 35.1158 33.8907 35.8222 33.5981C36.5287 33.3055 37.1706 32.8766 37.7113 32.3358C38.252 31.7951 38.681 31.1532 38.9736 30.4468C39.2662 29.7403 39.4168 28.9831 39.4168 28.2184V14.7809C39.4168 14.0162 39.2662 13.2591 38.9736 12.5526C38.681 11.8461 38.252 11.2042 37.7113 10.6635C37.1706 10.1228 36.5287 9.69388 35.8222 9.40125C35.1158 9.10862 34.3586 8.95801 33.5939 8.95801H9.40641ZM6.271 14.7809C6.271 13.0484 7.67387 11.6455 9.40641 11.6455H33.5939C35.3265 11.6455 36.7293 13.0484 36.7293 14.7809V28.2184C36.7293 29.05 36.399 29.8475 35.811 30.4355C35.223 31.0235 34.4255 31.3538 33.5939 31.3538H9.40641C8.57485 31.3538 7.77734 31.0235 7.18934 30.4355C6.60133 29.8475 6.271 29.05 6.271 28.2184V14.7809Z"
          fill={fill || '#FF6606'}
        />
      </svg>
    );
  }
  if (name === Icons.AddCircleOutline) {
    return (
      <svg
        width="28"
        height="40"
        viewBox="0 0 28 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="14" cy="26" r="13.5" fill="white" stroke="#7A7C87" />
        <path
          d="M21.47 24.405V27.645H16.16V33.405H12.56V27.645H7.25V24.405H12.56V18.645H16.16V24.405H21.47Z"
          fill="#7A7C87"
        />
      </svg>
    );
  }
  if (name === Icons.UncheckBox) {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="9" cy="9" r="8.5" fill="white" stroke="#FF6600" />
      </svg>
    );
  }
  if (name === Icons.CheckedBox) {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="9" cy="9" r="8.5" fill="#FF6600" stroke="#FF6600" />
        <path
          d="M6 9.25L7.96875 11.2188L11.9062 7"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === Icons.EditProfile) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5 9.25H2C1.59 9.25 1.25 8.91 1.25 8.5C1.25 8.09 1.59 7.75 2 7.75H11.5C11.91 7.75 12.25 8.09 12.25 8.5C12.25 8.91 11.91 9.25 11.5 9.25Z"
          fill={fill || '#BEC0C1'}
        />
        <path
          d="M8 17.25H6C5.59 17.25 5.25 16.91 5.25 16.5C5.25 16.09 5.59 15.75 6 15.75H8C8.41 15.75 8.75 16.09 8.75 16.5C8.75 16.91 8.41 17.25 8 17.25Z"
          fill={fill || '#BEC0C1'}
        />
        <path
          d="M14.5 17.25H10.5C10.09 17.25 9.75 16.91 9.75 16.5C9.75 16.09 10.09 15.75 10.5 15.75H14.5C14.91 15.75 15.25 16.09 15.25 16.5C15.25 16.91 14.91 17.25 14.5 17.25Z"
          fill={fill || '#BEC0C1'}
        />
        <path
          d="M17.56 21.25H6.44C2.46 21.25 1.25 20.05 1.25 16.11V7.89C1.25 3.95 2.46 2.75 6.44 2.75H14.5C14.91 2.75 15.25 3.09 15.25 3.5C15.25 3.91 14.91 4.25 14.5 4.25H6.44C3.3 4.25 2.75 4.79 2.75 7.89V16.1C2.75 19.2 3.3 19.74 6.44 19.74H17.55C20.69 19.74 21.24 19.2 21.24 16.1V12.02C21.24 11.61 21.58 11.27 21.99 11.27C22.4 11.27 22.74 11.61 22.74 12.02V16.1C22.75 20.05 21.54 21.25 17.56 21.25Z"
          fill={fill || '#BEC0C1'}
        />
        <path
          d="M15.5194 11.4401C15.1294 11.4401 14.7594 11.3001 14.4994 11.0301C14.1794 10.7101 14.0394 10.2501 14.1094 9.77005L14.3094 8.35005C14.3594 7.99005 14.5794 7.56005 14.8294 7.31005L18.5394 3.60005C20.0094 2.13005 21.2894 2.97005 21.9294 3.60005C22.5594 4.23005 23.3994 5.51005 21.9294 6.99005L18.2194 10.7001C17.9594 10.9601 17.5294 11.1701 17.1794 11.2201L15.7594 11.4201C15.6794 11.4301 15.5994 11.4401 15.5194 11.4401ZM20.2294 4.28005C20.0294 4.28005 19.8494 4.42005 19.5994 4.66005L15.8994 8.37005C15.8694 8.41005 15.8094 8.52005 15.7994 8.57005L15.5994 9.92005L16.9594 9.73005C17.0094 9.72005 17.1194 9.66005 17.1594 9.63005L20.8694 5.92005C21.3394 5.45005 21.4094 5.19005 20.8694 4.66005C20.6094 4.40005 20.4194 4.28005 20.2294 4.28005Z"
          fill={fill || '#BEC0C1'}
        />
        <path
          d="M20.8702 7.74006C20.8002 7.74006 20.7302 7.73006 20.6702 7.71006C19.3002 7.32006 18.2102 6.24006 17.8302 4.87006C17.7202 4.47006 17.9502 4.06006 18.3502 3.94006C18.7502 3.83006 19.1602 4.06006 19.2802 4.46006C19.5302 5.33006 20.2202 6.02006 21.0902 6.27006C21.4902 6.38006 21.7202 6.80006 21.6102 7.19006C21.5002 7.52006 21.2002 7.74006 20.8702 7.74006Z"
          fill={fill || '#BEC0C1'}
        />
      </svg>
    );
  }
  if (name === Icons.Add) {
    return (
      <svg
        width={width || '5'}
        height={height || '9'}
        viewBox="0 0 10 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.55556 6.05556V9.94444C5.55556 10.0918 5.49702 10.2331 5.39284 10.3373C5.28865 10.4415 5.14734 10.5 5 10.5C4.85266 10.5 4.71135 10.4415 4.60716 10.3373C4.50298 10.2331 4.44444 10.0918 4.44444 9.94444V6.05556H0.555556C0.408213 6.05556 0.266905 5.99702 0.162718 5.89284C0.0585316 5.78865 0 5.64734 0 5.5C0 5.35266 0.0585316 5.21135 0.162718 5.10716C0.266905 5.00298 0.408213 4.94444 0.555556 4.94444H4.44444V1.05556C4.44444 0.908213 4.50298 0.766905 4.60716 0.662718C4.71135 0.558532 4.85266 0.5 5 0.5C5.14734 0.5 5.28865 0.558532 5.39284 0.662718C5.49702 0.766905 5.55556 0.908213 5.55556 1.05556V4.94444H9.44444C9.59179 4.94444 9.7331 5.00298 9.83728 5.10716C9.94147 5.21135 10 5.35266 10 5.5C10 5.64734 9.94147 5.78865 9.83728 5.89284C9.7331 5.99702 9.59179 6.05556 9.44444 6.05556H5.55556Z"
          fill={fill || '#FF7A00'}
        />
      </svg>
    );
  }
  if (name === Icons.VectorRight) {
    return (
      <svg
        width={width || '5'}
        height={height || '9'}
        viewBox="0 0 5 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.112099 1.13304L4.09705 4.56088L0.1121 7.98872C0.0407579 8.04997 0.000817847 8.13218 0.000817851 8.21779C0.000817856 8.3034 0.0407579 8.38562 0.1121 8.44686C0.14675 8.47652 0.188109 8.50008 0.233755 8.51616C0.2794 8.53224 0.328415 8.54053 0.377926 8.54053C0.427438 8.54053 0.476451 8.53224 0.522097 8.51616C0.567742 8.50008 0.609102 8.47652 0.643753 8.44686L4.88389 4.80024C4.95834 4.7362 5 4.65031 5 4.56088C5 4.47145 4.95834 4.38556 4.88389 4.32152L0.644571 0.674892C0.609894 0.645028 0.568433 0.621292 0.522636 0.605084C0.476839 0.588877 0.427634 0.580527 0.377926 0.580527C0.328217 0.580527 0.279012 0.588877 0.233215 0.605084C0.187418 0.621292 0.145958 0.645028 0.111281 0.674892C0.0399392 0.736136 -4.24054e-07 0.818352 -4.19353e-07 0.903964C-4.14652e-07 0.989576 0.0407575 1.07179 0.112099 1.13304Z"
          fill={fill || '#FFFFFF'}
        />
      </svg>
    );
  }
  if (name === Icons.Minus) {
    return (
      <svg
        className="h-1 w-3 text-gray-900 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 18 2"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M1 1h16"
        />
      </svg>
    );
  }
  if (name === Icons.Addition) {
    return (
      <svg
        className="h-3 w-3"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill={fill || '#000000'}
        viewBox="0 0 18 18"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 1v16M1 9h16"
          fill={fill || '#000000'}
        />
      </svg>
    );
  }
  if (name === Icons.ArrowLeft) {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.707 2.29279C6.51947 2.10532 6.26516 2 6 2C5.73484 2 5.48053 2.10532 5.293 2.29279L0.793 6.79279C0.605529 6.98031 0.500214 7.23462 0.500214 7.49979C0.500214 7.76495 0.605529 8.01926 0.793 8.20679L5.293 12.7068C5.4816 12.8889 5.7342 12.9897 5.9964 12.9875C6.2586 12.9852 6.50941 12.88 6.69482 12.6946C6.88023 12.5092 6.9854 12.2584 6.98767 11.9962C6.98995 11.734 6.88916 11.4814 6.707 11.2928L4 8.49979H13.5C13.7652 8.49979 14.0196 8.39443 14.2071 8.20689C14.3946 8.01936 14.5 7.765 14.5 7.49979C14.5 7.23457 14.3946 6.98022 14.2071 6.79268C14.0196 6.60514 13.7652 6.49979 13.5 6.49979H4L6.707 3.70679C6.89447 3.51926 6.99979 3.26495 6.99979 2.99979C6.99979 2.73462 6.89447 2.48031 6.707 2.29279Z"
          fill={fill || '#FF6606'}
        />
      </svg>
    );
  }
  if (name === Icons.Users) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 7.16C17.94 7.15 17.87 7.15 17.81 7.16C16.43 7.11 15.33 5.98 15.33 4.58C15.33 3.15 16.48 2 17.91 2C19.34 2 20.49 3.16 20.49 4.58C20.48 5.98 19.38 7.11 18 7.16Z"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.97 14.44C18.34 14.67 19.85 14.43 20.91 13.72C22.32 12.78 22.32 11.24 20.91 10.3C19.84 9.59004 18.31 9.35003 16.94 9.59003"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.97001 7.16C6.03001 7.15 6.10001 7.15 6.16001 7.16C7.54001 7.11 8.64001 5.98 8.64001 4.58C8.64001 3.15 7.49001 2 6.06001 2C4.63001 2 3.48001 3.16 3.48001 4.58C3.49001 5.98 4.59001 7.11 5.97001 7.16Z"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 14.44C5.63 14.67 4.12 14.43 3.06 13.72C1.65 12.78 1.65 11.24 3.06 10.3C4.13 9.59004 5.66 9.35003 7.03 9.59003"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 14.63C11.94 14.62 11.87 14.62 11.81 14.63C10.43 14.58 9.33002 13.45 9.33002 12.05C9.33002 10.62 10.48 9.46997 11.91 9.46997C13.34 9.46997 14.49 10.63 14.49 12.05C14.48 13.45 13.38 14.59 12 14.63Z"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.09 17.78C7.68 18.72 7.68 20.26 9.09 21.2C10.69 22.27 13.31 22.27 14.91 21.2C16.32 20.26 16.32 18.72 14.91 17.78C13.32 16.72 10.69 16.72 9.09 17.78Z"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === Icons.SingleUser) {
    return (
      <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <rect width={20} height={20} fill="url(#pattern0)" />
        <defs>
          <pattern
            id="pattern0"
            patternContentUnits="objectBoundingBox"
            width={1}
            height={1}
          >
            <use xlinkHref="#image0_6481_6201" transform="scale(0.0111111)" />
          </pattern>
          <image
            id="image0_6481_6201"
            width={90}
            height={90}
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAAEdElEQVR4nO2dTahVVRiGn+9qijfMyropqf1glmERhtxyEiJkFEVljWsQQo0iaBA0qklRUfMGFdWoooEjSRBKkqhLVnaV2w/h6e+GhJZlZfo2WOfA9eQ9rn3u2d9aZ7ue8d7nXd9z1tk/a6+9DhQKhUKhUCgUCoVCpljqBsyGpBFgI7AJuBFYAywDFrc3+R34GZgCPgF2AXvM7KR/a4cQSRdLelrS96pOS9JTki5KXUe2SFog6UlJf/QhuJujkp6QtCB1XVkhabWkTwcguJsJSVekri8LJI1L+rUGyR0OSdqQus6kSFov6UiNkjsclnRDylqTXXVIWg58DFzqFNkCNpjZtFPeKYykCG3zMn6SAVa2M88eJN3ncLiYjbtT1Ox+6JA0H5gErvLObnMAWGdmJzxDUxw67iKdZIBrgDu8Q1OIfihBZjfbvANdDx2SlgC/AKnv2P4GxszsN69A7x69mfSSARYSBqvc8BZ9k3NeL8Y9w7xFr3PO68X1nmHeonMa4LncM8xb9CXOeb1Y5hnmLXrUOa8X53qGeYtOObbSzTzPMO/C3a5bIzjsGeYt+ohzXi8aLfpH57xe/OQZ5i16n3NeL77wDDubRbu2xVv0R855vXBti/fo3Qjh2DjmmXsapoHlZiavQNce3Z6utdMzcxZ2eEqGNDcQ7yTI7Ma9DameGbZwHmuYwTSw0syOe4a692gz+xd40zt3Bq97S4ZEE2gkrQK+wv9py3FgjZl955ybZpDHzA4CbySIfjWFZEg7JWw18CV+vfofYK2ZfeuUdwrJhi3N7GvgJcfIF1JJhsSvVkgaJcxauqzmqBZwrZkdrTlnVpIOxJvZn8DDQJ03DwK2pZScDZKer3FS47Op68sGhfdXPqhB8vuSzkldX1ZIWiJp7wAl75N0Qeq6OmT1nqGkFYQT1yBYYWY/DOiz5kxWogEkDeTEaGZZ1ZbT4/9GU0Q7UUQ7UUQ7UUQ7UUQ7kZVoSZtz/KxGIWlUYTWCQTGhMDpY6CDpPEk7Byi5w3uSFp+5BQ1Hkim8rtzPajOxtCRtlZTVnaILksYkPSJpf42Cu5lsZyaZJeX2LSsMGN0O3AncBsz3yu7iJLAH2A68bWbfeITWKlrSlQSx9xNW/Mrx5zsJvAVsN7OJukIGXriktcADwD2EJdSGiSngXeA1M9ufujH/Q+Gkdq+k3Y7H3LrZrVBTHr9CSVskfZbWSa3slbRlrp76/rYknQ+8CDw410YMCa8Aj5lZXy8Z9SVaYeGpHcB1/ew/xBwAbjWzyo/bKotWuJLYBayqum9DOAhsqjrrqZJoSQuBD4H1VfZrIJ8D42b2V+wOVUfvnqNIhrAExTNVdoju0QprfE6R7o4uN04AV8feWVbp0Y9TJM9kHvBo7MZRPVphXPcQsKjPRjWVY8BSMzt2pg1je/RGiuTTsQi4OWbDWNG39N+WxhPlJla064paQ0bUymexonNaCyk3oh4kxIpeOoeGNJ0oN7GiL5xDQ5pO+YeMQqFQKBQKhUKhMNz8B8TTYDRw4ZZzAAAAAElFTkSuQmCC"
          />
        </defs>
      </svg>
    );
  }
  if (name === Icons.MultipleUser) {
    return (
      <svg
        width={24}
        height={23}
        viewBox="0 0 24 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect y={-1} width={24} height={24} fill="url(#pattern0)" />
        <defs>
          <pattern
            id="pattern0"
            patternContentUnits="objectBoundingBox"
            width={1}
            height={1}
          >
            <use xlinkHref="#image0_6481_6716" transform="scale(0.0111111)" />
          </pattern>
          <image
            id="image0_6481_6716"
            width={90}
            height={90}
            xlinkHref="data:image/png;base64,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"
          />
        </defs>
      </svg>
    );
  }
  if (name === Icons.Customer) {
    return (
      <svg
        width={80}
        height={80}
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width={80}
          height={80}
          rx={40}
          fill="url(#paint0_linear_1794_7657)"
        />
        <path
          d="M35.9999 26.6665C32.5066 26.6665 29.6666 29.5065 29.6666 32.9998C29.6666 36.4265 32.3466 39.1998 35.8399 39.3198C35.9466 39.3065 36.0533 39.3065 36.1333 39.3198C36.1599 39.3198 36.1733 39.3198 36.1999 39.3198C36.2133 39.3198 36.2133 39.3198 36.2266 39.3198C39.6399 39.1998 42.3199 36.4265 42.3333 32.9998C42.3333 29.5065 39.4933 26.6665 35.9999 26.6665Z"
          fill="#2DC8A8"
        />
        <path
          d="M42.7733 42.8665C39.0533 40.3865 32.9866 40.3865 29.2399 42.8665C27.5466 43.9998 26.6133 45.5332 26.6133 47.1732C26.6133 48.8132 27.5466 50.3332 29.2266 51.4532C31.0933 52.7065 33.5466 53.3332 35.9999 53.3332C38.4533 53.3332 40.9066 52.7065 42.7733 51.4532C44.4533 50.3198 45.3866 48.7998 45.3866 47.1465C45.3733 45.5065 44.4533 43.9865 42.7733 42.8665Z"
          fill="#2DC8A8"
        />
        <path
          d="M50.6533 33.7865C50.8666 36.3732 49.0266 38.6398 46.4799 38.9465C46.4666 38.9465 46.4666 38.9465 46.4533 38.9465H46.4133C46.3333 38.9465 46.2533 38.9465 46.1866 38.9732C44.8933 39.0398 43.7066 38.6265 42.8133 37.8665C44.1866 36.6398 44.9733 34.7998 44.8133 32.7998C44.7199 31.7198 44.3466 30.7332 43.7866 29.8932C44.2933 29.6398 44.8799 29.4798 45.4799 29.4265C48.0933 29.1998 50.4266 31.1465 50.6533 33.7865Z"
          fill="#2DC8A8"
        />
        <path
          d="M53.3199 46.1198C53.2133 47.4132 52.3866 48.5332 51 49.2932C49.6666 50.0265 47.9866 50.3732 46.3199 50.3332C47.2799 49.4665 47.8399 48.3865 47.9466 47.2398C48.0799 45.5865 47.2933 43.9998 45.7199 42.7332C44.8266 42.0265 43.7866 41.4665 42.6533 41.0532C45.5999 40.1998 49.3066 40.7732 51.5866 42.6132C52.8133 43.5998 53.4399 44.8398 53.3199 46.1198Z"
          fill="#2DC8A8"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1794_7657"
            x1={40}
            y1={0}
            x2={40}
            y2={80}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2DC8A8" stopOpacity="0.5" />
            <stop offset={1} stopColor="white" stopOpacity={0} />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  if (name === Icons.Prospect) {
    return (
      <svg
        width={80}
        height={80}
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width={80}
          height={80}
          rx={40}
          fill="url(#paint0_linear_1794_7663)"
        />
        <path
          d="M52.1194 33.3065C50.9861 32.0532 49.0927 31.4265 46.3461 31.4265H46.0261V31.3732C46.0261 29.1332 46.0261 26.3599 41.0127 26.3599H38.9861C33.9727 26.3599 33.9727 29.1465 33.9727 31.3732V31.4399H33.6527C30.8927 31.4399 29.0127 32.0665 27.8794 33.3199C26.5594 34.7865 26.5994 36.7599 26.7327 38.1065L26.7461 38.1999L26.8493 39.2842C26.8684 39.4839 26.9759 39.6643 27.1438 39.7742C27.4635 39.9834 27.9986 40.3283 28.3194 40.5065C28.5061 40.6265 28.7061 40.7332 28.9061 40.8399C31.1861 42.0932 33.6927 42.9332 36.2394 43.3465C36.3594 44.5999 36.9061 46.0665 39.8261 46.0665C42.7461 46.0665 43.3194 44.6132 43.4127 43.3199C46.1327 42.8799 48.7594 41.9332 51.1327 40.5465C51.2127 40.5065 51.2661 40.4665 51.3327 40.4265C51.8617 40.1276 52.4105 39.7592 52.9107 39.3983C53.0614 39.2896 53.1577 39.1215 53.1783 38.9369L53.1994 38.7465L53.2661 38.1199C53.2794 38.0399 53.2794 37.9732 53.2927 37.8799C53.3994 36.5332 53.3727 34.6932 52.1194 33.3065ZM41.4527 42.4399C41.4527 43.8532 41.4527 44.0665 39.8127 44.0665C38.1727 44.0665 38.1727 43.8132 38.1727 42.4532V40.7732H41.4527V42.4399ZM35.8794 31.3732C35.8794 29.1065 35.8794 28.2665 38.9861 28.2665H41.0127C44.1194 28.2665 44.1194 29.1199 44.1194 31.3732V31.4399H35.8794V31.3732Z"
          fill="#FE8084"
        />
        <path
          d="M51.8307 42.3121C52.3022 42.0878 52.8452 42.4615 52.798 42.9814L52.3194 48.2532C52.0394 50.9199 50.9461 53.6399 45.0794 53.6399H34.9194C29.0527 53.6399 27.9594 50.9199 27.6794 48.2665L27.2251 43.2694C27.1784 42.7555 27.709 42.3822 28.1792 42.5949C29.6984 43.2823 32.5026 44.5017 34.2348 44.9554C34.4539 45.0128 34.6311 45.1696 34.727 45.3747C35.5363 47.1056 37.2915 48.0265 39.8261 48.0265C42.3355 48.0265 44.1129 47.0701 44.9249 45.335C45.021 45.1297 45.1984 44.973 45.4176 44.9153C47.257 44.4313 50.2418 43.0682 51.8307 42.3121Z"
          fill="#FE8084"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1794_7663"
            x1={40}
            y1={0}
            x2={40}
            y2={80}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FE8084" stopOpacity="0.5" />
            <stop offset={1} stopColor="white" stopOpacity={0} />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  if (name === Icons.iWillCompleted) {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="80" height="80" rx="40" fill="url(#paint0_linear_0_1)" />
        <path
          d="M39.0625 31.4996V48.8871C39.0625 49.7746 38.1625 50.3871 37.35 50.0496C35.025 49.0746 32.1375 48.2246 30.0875 47.9496L29.7 47.8996C28.4875 47.7496 27.5 46.6371 27.5 45.4246V30.5621C27.5 29.0621 28.7125 27.8496 30.2125 27.8496H30.3C32.65 28.0496 36.1125 29.1496 38.4 30.3871C38.8125 30.6121 39.0625 31.0246 39.0625 31.4996Z"
          fill="#FF4E75"
        />
        <path
          d="M49.7875 27.8496H49.7125C49.4125 27.8746 49.0875 27.9121 48.75 27.9746C47.2125 28.2246 45.3875 28.7496 43.75 29.3996C42.975 29.7121 42.25 30.0496 41.6125 30.3871C41.2 30.6121 40.9375 31.0371 40.9375 31.4996V48.8871C40.9375 49.7746 41.8375 50.3871 42.65 50.0496C44.975 49.0746 47.8625 48.2246 49.9125 47.9496L50.3 47.8996C51.5125 47.7496 52.5 46.6371 52.5 45.4246V30.5621C52.5 29.0621 51.2875 27.8496 49.7875 27.8496ZM49.0875 41.1621C49.0875 41.6496 48.7375 41.8621 48.3125 41.6246L46.9875 40.8871C46.85 40.8121 46.625 40.8121 46.475 40.8871L45.15 41.6246C44.725 41.8621 44.375 41.6496 44.375 41.1621V37.3246C44.375 36.7496 44.85 36.2746 45.425 36.2746H48.05C48.625 36.2746 49.1 36.7496 49.1 37.3246V41.1621H49.0875Z"
          fill="#FF4E75"
        />
        <defs>
          <linearGradient
            id="paint0_linear_0_1"
            x1="40"
            y1="0"
            x2="40"
            y2="80"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF4E75" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  if (name === Icons.iWillPending) {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="80"
          height="80"
          rx="40"
          fill="url(#paint0_linear_1799_14815)"
        />

        <rect
          width={80}
          height={80}
          rx={40}
          fill="url(#paint0_linear_1794_7663)"
        />
        <path
          d="M46.7369 43.5875L41.6869 39H38.2994L33.2494 43.5875C31.8369 44.8625 31.3744 46.825 32.0619 48.6C32.7494 50.3625 34.4244 51.5 36.3119 51.5H43.6744C45.5744 51.5 47.2369 50.3625 47.9244 48.6C48.6119 46.825 48.1494 44.8625 46.7369 43.5875ZM42.2744 46.675H37.7244C37.2494 46.675 36.8744 46.2875 36.8744 45.825C36.8744 45.3625 37.2619 44.975 37.7244 44.975H42.2744C42.7494 44.975 43.1244 45.3625 43.1244 45.825C43.1244 46.2875 42.7369 46.675 42.2744 46.675Z"
          fill="#FF6600"
        />
        <path
          d="M47.9383 29.4C47.2508 27.6375 45.5758 26.5 43.6883 26.5H36.3133C34.4258 26.5 32.7508 27.6375 32.0633 29.4C31.3883 31.175 31.8508 33.1375 33.2633 34.4125L38.3133 39H41.7008L46.7508 34.4125C48.1508 33.1375 48.6133 31.175 47.9383 29.4ZM42.2758 33.0375H37.7258C37.2508 33.0375 36.8758 32.65 36.8758 32.1875C36.8758 31.725 37.2633 31.3375 37.7258 31.3375H42.2758C42.7508 31.3375 43.1258 31.725 43.1258 32.1875C43.1258 32.65 42.7383 33.0375 42.2758 33.0375Z"
          fill="#FF6600"
        />
        <defs>
          <linearGradient
            id="paint0_linear_0_1"
            x1="40"
            y1="0"
            x2="40"
            y2="80"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF6600" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  if (name === Icons.ExportArrowUp) {
    return (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1792_8408)">
          <path
            d="M8.00063 10.9999C8.13324 10.9999 8.26042 10.9472 8.35419 10.8535C8.44795 10.7597 8.50063 10.6325 8.50063 10.4999V6.70692L9.64663 7.85392C9.74052 7.9478 9.86786 8.00055 10.0006 8.00055C10.1334 8.00055 10.2607 7.9478 10.3546 7.85392C10.4485 7.76003 10.5013 7.63269 10.5013 7.49992C10.5013 7.36714 10.4485 7.2398 10.3546 7.14592L8.35463 5.14592C8.30819 5.09935 8.25301 5.06241 8.19227 5.0372C8.13152 5.012 8.0664 4.99902 8.00063 4.99902C7.93486 4.99902 7.86974 5.012 7.809 5.0372C7.74825 5.06241 7.69308 5.09935 7.64663 5.14592L5.64663 7.14592C5.55275 7.2398 5.5 7.36714 5.5 7.49992C5.5 7.63269 5.55275 7.76003 5.64663 7.85392C5.74052 7.9478 5.86786 8.00055 6.00063 8.00055C6.13341 8.00055 6.26075 7.9478 6.35463 7.85392L7.50063 6.70692V10.4999C7.50063 10.6325 7.55331 10.7597 7.64708 10.8535C7.74085 10.9472 7.86802 10.9999 8.00063 10.9999Z"
            fill="#1D1929"
          />
          <path
            d="M4 0C3.46957 0 2.96086 0.210714 2.58579 0.585786C2.21071 0.960859 2 1.46957 2 2V14C2 14.5304 2.21071 15.0391 2.58579 15.4142C2.96086 15.7893 3.46957 16 4 16H12C12.5304 16 13.0391 15.7893 13.4142 15.4142C13.7893 15.0391 14 14.5304 14 14V2C14 1.46957 13.7893 0.960859 13.4142 0.585786C13.0391 0.210714 12.5304 0 12 0L4 0ZM4 1H12C12.2652 1 12.5196 1.10536 12.7071 1.29289C12.8946 1.48043 13 1.73478 13 2V14C13 14.2652 12.8946 14.5196 12.7071 14.7071C12.5196 14.8946 12.2652 15 12 15H4C3.73478 15 3.48043 14.8946 3.29289 14.7071C3.10536 14.5196 3 14.2652 3 14V2C3 1.73478 3.10536 1.48043 3.29289 1.29289C3.48043 1.10536 3.73478 1 4 1Z"
            fill="#1D1929"
          />
        </g>
        <defs>
          <clipPath id="clip0_1792_8408">
            <rect width={16} height={16} fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (name === Icons.CircleUp) {
    return (
      <svg
        className="absolute right-0 top-0"
        width="92"
        height="68"
        viewBox="0 0 92 68"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="62" cy="6" r="62" fill={fill || '#878995'} />
      </svg>
    );
  }
  if (name === Icons.CircleDown) {
    return (
      <svg
        className="absolute bottom-0 left-0"
        width="52"
        height="62"
        viewBox="0 0 52 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="-44.5" cy="96.5" r="96.5" fill={fill || '#878995'} />
      </svg>
    );
  }
  if (name === Icons.ArrowLeftCircle) {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 0C3.58185 0 0 3.58185 0 8C0 12.4181 3.58185 16 8 16C12.4181 16 16 12.4181 16 8C16 3.58185 12.4181 0 8 0ZM8 15.2426C4.00789 15.2426 0.757397 11.9921 0.757397 8C0.757397 4.00789 4.00789 0.757397 8 0.757397C11.9921 0.757397 15.2426 4.00789 15.2426 8C15.2426 11.9921 11.9921 15.2426 8 15.2426Z"
          fill={fill || '#7A7C87'}
        />
        <path
          d="M11.4334 7.57887H5.38735L7.5548 4.92297C7.68314 4.76571 7.68314 4.48614 7.5548 4.32888C7.42647 4.17162 7.19831 4.17162 7.06998 4.32888L4.30362 7.70118C4.27511 7.73613 4.24659 7.78855 4.23233 7.84097C4.20381 7.94581 4.20381 8.06812 4.23233 8.15549C4.24659 8.2079 4.27511 8.26032 4.30362 8.29527L7.06998 11.6676C7.14127 11.7549 7.22683 11.7899 7.31239 11.7899C7.39795 11.7899 7.4835 11.7549 7.5548 11.6676C7.68314 11.5103 7.68314 11.2307 7.5548 11.0735L5.38735 8.41758H11.4477C11.633 8.41758 11.7899 8.22538 11.7899 7.99823C11.7899 7.77108 11.633 7.57887 11.4334 7.57887Z"
          fill={fill || '#7A7C87'}
        />
      </svg>
    );
  }
  if (name === Icons.TwoUsers) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 4.00018C6.93913 4.00018 5.92172 4.42161 5.17157 5.17175C4.42143 5.9219 4 6.93931 4 8.00018C4 9.06104 4.42143 10.0785 5.17157 10.8286C5.92172 11.5788 6.93913 12.0002 8 12.0002C9.06087 12.0002 10.0783 11.5788 10.8284 10.8286C11.5786 10.0785 12 9.06104 12 8.00018C12 6.93931 11.5786 5.9219 10.8284 5.17175C10.0783 4.42161 9.06087 4.00018 8 4.00018ZM6 13.0002C4.93913 13.0002 3.92172 13.4216 3.17157 14.1718C2.42143 14.9219 2 15.9393 2 17.0002V18.0002C2 19.1002 2.9 20.0002 4 20.0002H12C12.5304 20.0002 13.0391 19.7895 13.4142 19.4144C13.7893 19.0393 14 18.5306 14 18.0002V17.0002C14 15.9393 13.5786 14.9219 12.8284 14.1718C12.0783 13.4216 11.0609 13.0002 10 13.0002H6ZM13.3 11.0002C13.8266 10.0881 14.1038 9.0534 14.1038 8.00018C14.1038 6.94696 13.8266 5.91229 13.3 5.00018C13.8756 4.47348 14.5926 4.12662 15.3629 4.00229C16.1331 3.87796 16.9229 3.9816 17.635 4.30044C18.347 4.61928 18.9503 5.1394 19.3705 5.79677C19.7908 6.45413 20.0096 7.22004 20 8.00018C20.0096 8.78032 19.7908 9.54623 19.3705 10.2036C18.9503 10.861 18.347 11.3811 17.635 11.6999C16.9229 12.0188 16.1331 12.1224 15.3629 11.9981C14.5926 11.8737 13.8756 11.5269 13.3 11.0002ZM15.5 20.0002C15.8386 19.3886 16.0109 18.6991 16 18.0002V17.0002C16.0077 15.528 15.4738 14.1043 14.5 13.0002H18C19.0609 13.0002 20.0783 13.4216 20.8284 14.1718C21.5786 14.9219 22 15.9393 22 17.0002V18.0002C22 18.5306 21.7893 19.0393 21.4142 19.4144C21.0391 19.7895 20.5304 20.0002 20 20.0002H15.5Z"
          fill={fill || '#FFFFFF'}
        />
      </svg>
    );
  }
  if (name === Icons.Upload) {
    return (
      <svg
        width={width ?? '48'}
        height={height ?? '48'}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24 6C17.82 6 12.96 10.695 12.2805 16.6875C10.9735 16.8981 9.74769 17.4582 8.73293 18.3085C7.71816 19.1587 6.95216 20.2675 6.516 21.5175C2.826 22.581 0 25.872 0 30C0 34.986 4.014 39 9 39H39C43.986 39 48 34.986 48 30C48 27.36 46.7175 24.996 44.859 23.343C44.511 18.072 40.3065 13.866 35.016 13.593C33.21 9.1995 29.067 6 24 6ZM24 9C28.143 9 31.455 11.655 32.625 15.42L32.955 16.5H34.5C38.6325 16.5 42 19.8675 42 24V24.75L42.609 25.2195C43.344 25.7828 43.9412 26.5059 44.3555 27.3342C44.7697 28.1624 44.9901 29.074 45 30C45 33.414 42.414 36 39 36H9C5.586 36 3 33.414 3 30C3 26.97 5.175 24.618 7.92 24.141L8.9055 23.9535L9.093 22.9665C9.543 20.946 11.334 19.5 13.5 19.5H15V18C15 12.945 18.945 9 24 9ZM24 17.391L22.92 18.4215L16.92 24.4215L19.08 26.5815L22.5 23.1555V33H25.5V23.1555L28.92 26.5785L31.08 24.4185L25.08 18.4185L24 17.391Z"
          fill={fill || '#FF6600'}
        />
      </svg>
    );
  }
  if (name === Icons.Note) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 2V5"
          stroke="#585858"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 2V5"
          stroke="#585858"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
          stroke="#585858"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 11H16"
          stroke="#585858"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 16H12"
          stroke="#585858"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (name === Icons.CircleSuccess) {
    return (
      <svg
        width="102"
        height="102"
        viewBox="0 0 102 102"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="51" cy="51" r="51" fill="#E30000" fillOpacity="0.06" />
        <path
          d="M42.9558 59.3109C42.5665 59.6935 41.9425 59.6933 41.5535 59.3106L32.9739 50.8702C31.8093 49.7245 29.9422 49.7212 28.7736 50.8628L27.7606 51.8523C26.5587 53.0264 26.5553 54.9586 27.7531 56.1369L40.1502 68.333C41.3177 69.4816 43.1905 69.4816 44.358 68.333L74.2521 38.9238C75.4469 37.7484 75.4469 35.8221 74.2521 34.6466L73.2556 33.6663C72.0885 32.5182 70.2164 32.5177 69.0488 33.6653L42.9558 59.3109Z"
          fill="#FF6600"
          stroke="#FF6600"
          strokeWidth="2"
        />
      </svg>
    );
  }
}
